import {
  AlignmentDocumentControlNo,
  AmountInfoSettingType,
  BankAccountType,
  CurrencyCode,
  CurrencyRatio,
  DateOptionType,
  DepositExpenseHeaderType,
  DiscountType,
  DocumentFontType,
  DocumentFormat,
  DocumentHeaderSize,
  DocumentType,
  ExpenseHeaderType,
  ExpenseType,
  FinanceType,
  ItemsDocumentType,
  JournalHeaderType,
  LanguageType,
  MerchantType,
  OptionType,
  OrdinaryPersonPrefixType,
  PaymentElementType,
  ProductVatType,
  ReceiptHeaderType,
  SettingAreaPunchingType,
  SettingCertifiedDate,
  SettingWhtItem40XShowingType,
  TaxStatusType,
  TransactionType,
  WhtAmountType,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import { AllocationItemModel } from "@/model/allocation/allocationModel";
import { OrdinaryPersonModel } from "@/model/contact/contactModel";
import {
  ContactEnvelopeDocumentTemplateModel,
  ContactEnvelopeOnlineViewModel,
} from "@/model/document/contactEnvelopeModel";
import {
  ClassificationItem,
  CurrencyDetailModel,
  DepositReferenceItemModel,
  DetailDocumentModel,
  DocumentCurrencyModel,
  DocumentDataModel,
  DocumentItemAssetGroupBaseModel,
  DocumentItemBaseModel,
  DocumentTemplateModel,
  DocumentWhtModel,
  ElementAmountInfoModel,
  ElementAssetGroupItemModel,
  ElementAssetItemModel,
  ElementBillingItemModel,
  ElementBillingNoteProductItemModel,
  ElementCertifiedModel,
  ElementContactModel,
  ElementDefaultModel,
  ElementDocumentInfoModel,
  ElementDocumentNameModel,
  ElementExpenseClaimDetailModel,
  ElementHeadTypeModel,
  ElementMerchantModel,
  ElementMerchantPaymentModel,
  ElementMerchantPersonModel,
  ElementProductItemModel,
  ElementSettigColumnModel,
  ElementSettigDescriptionModel,
  ElementSummarizeInfoModel,
  FooterDocumentModel,
  HeaderBillingColumnModel,
  HeaderBillingProductItemColumnModel,
  HeaderDocumentModel,
  HeaderItemColumnModel,
  OnlineViewCustomizeModel,
  OnlineViewModel,
  PaymentGroupModel,
  PaymentModel,
} from "@/model/document/documentModel";
import {
  ExecutiveSummaryDocumentTemplateModel,
  ExecutiveSummaryOnlineViewModel,
} from "@/model/document/executiveSummaryModel";
import { JournalDocumentTemplateModel, JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { PndDocumentTemplateModel, PndOnlineViewModel } from "@/model/document/pndDocumentModel";
import { PP30DocumentTemplateModel, PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import {
  SettingContactEnvelopeDocumentTemplateModel,
  SettingDocumentTemplateModel,
  SettingExecutiveSummaryDocumentTemplateModel,
  SettingJournalDocumentTemplateModel,
  SettingPP30DocumentTemplateModel,
  SettingPndDocumentTemplateModel,
  SettingWitholdingTaxDocumentTemplateModel,
} from "@/model/document/settingDocumentTemplate";
import {
  WithholdingTaxDocumentTemplateModel,
  WitholdingTaxOnlineViewModel,
} from "@/model/document/witholdingTaxDocumentModal";
import router from "@/router";
import { GetBillingNoteSettingDocument } from "@/service/document/BillingNote/billingNoteFacade";
import { GetCreditNoteSettingDocument } from "@/service/document/CreditNote/creditNoteFacade";
import { GetCreditNoteExpenseSettingDocument } from "@/service/document/CreditNoteExpense/creditNoteExpenseFacade";
import { GetDebitNoteExpenseSettingDocument } from "@/service/document/DebitNoteExpense/debitNoteExpenseFacade";
import { GetCombinePaymentNoteSettingDocument } from "@/service/document/combinePaymentNote/combinePaymentNoteFacade";
import { GetContactEnvelopeSettingDocument } from "@/service/document/contact/contactFacade";
import { GetJournalSettingDocument } from "@/service/document/dailyJournal/dailyJournalFacade";
import { GetDebitNoteSettingDocument } from "@/service/document/debitNote/debitNoteFacade";
import { GetDepositExpenseSettingDocument, GetDepositSettingDocument } from "@/service/document/deposit/depositFacade";
import { GetExecutiveSummarySettingDocument } from "@/service/document/executiveSummary/executiveSummaryFacade";
import { GetExpenseSettingDocument } from "@/service/document/expense/expenseFacade";
import { GetGoodsReceiptSettingDocument } from "@/service/document/goodsReceipt/goodsReceiptFacade";
import { GetInvoiceSettingDocument } from "@/service/document/invoice/invoiceFacade";
import { GetInvoiceReceiptSettingDocument } from "@/service/document/invoiceReceipt/invoiceReceiptFacade";
import { GetPndSettingDocument } from "@/service/document/pnd/pndFacade";
import { GetPP30SettingDocument } from "@/service/document/pp30/pp30Facade";
import { GetPurchaseOrderSettingDocument } from "@/service/document/purchaseOrder/purchaseOrderFacade";
import { GetPurchaseRequisitionSettingDocument } from "@/service/document/purchaseRequisition/purchaseRequisitionFacade";
import { GetQuotationSettingDocument } from "@/service/document/quotation/quatationFacade";
import { GetReceiptSettingDocument } from "@/service/document/receipt/receiptFacade";
import { GetTaxInvoiceSettingDocument } from "@/service/document/taxInvoice/taxInvoiceFacade";
import { GetWitholdingTaxSettingDocument } from "@/service/document/witholdingTax/WitholdingTaxFacade";
import { GetJournalNameTypeDefault } from "./JournalDocumentHelper";
import { ConvertToAddressDetail, GetAddress } from "./addressHelper";
import {
  ConvertAmountToEnglishWord,
  ConvertAmountToThaiWord,
  GetCurrencyCode,
  GetJournalTypeName,
  NewObject,
  StringToObject,
} from "./shareHelper";

const thailandTimeZone: number = 7;

function GetValueBySettingOrDefault(settingValue: any, defaultValue: any) {
  if (settingValue) {
    return settingValue;
  } else if (defaultValue) {
    return defaultValue;
  } else {
    return "-";
  }
}

export function GetMerchantLogo(
  documentModel: OnlineViewModel | JournalOnlineViewModel | PP30OnlineViewModel | ContactEnvelopeOnlineViewModel,
  settingDocumentTemplateDefault?:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
    | SettingContactEnvelopeDocumentTemplateModel
): ElementDefaultModel {
  const merchantLogo: ElementDefaultModel = {
    value: documentModel.document.data.merchant.logoUrl,
    isShowElement: documentModel.template.merchantLogo.isShowElement,
  };

  if (settingDocumentTemplateDefault) {
    merchantLogo.isShowElement = settingDocumentTemplateDefault.merchantLogo.isShowElement;
  }

  return merchantLogo;
}

export function GetHeadType(
  documentModel: OnlineViewModel | JournalOnlineViewModel | PP30OnlineViewModel,
  settingDocumentTemplateDefault?:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
): ElementHeadTypeModel {
  const headType: ElementHeadTypeModel = {
    copyAmount: documentModel.template.headType.copyAmount,
    originalAmount: documentModel.template.headType.originalAmount,
    headerOptionType: documentModel.template.headType.headerTitleType,
    isShowDocumentSet: documentModel.template.headType.isShowDocumentSet,
    isShowHeaderOptionType: documentModel.template.headType.isShowHeaderOptionType,
  };

  if (settingDocumentTemplateDefault) {
    headType.copyAmount = settingDocumentTemplateDefault.headType.copyAmount;
    headType.originalAmount = settingDocumentTemplateDefault.headType.originalAmount;
    headType.headerOptionType = settingDocumentTemplateDefault.headType.headerTitleType;
    headType.isShowDocumentSet = settingDocumentTemplateDefault.headType.isShowDocumentSet;
    headType.isShowHeaderOptionType = settingDocumentTemplateDefault.headType.isShowHeaderOptionType;
  }
  return headType;
}

export function GetDocumentName(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementDocumentNameModel {
  let documentName: ElementDocumentNameModel = {
    headerOptionName: documentModel.template.documentName.headerOptionType,
    documentHeaderSize: documentModel.template.documentName.documentHeaderSize ?? DocumentHeaderSize.Medium,
    isShowTaxInvoice: documentModel.template.documentName.isShowTaxInvoice ?? true,
    isShowNonTaxInvoice: documentModel.template.documentName.isShowNonTaxInvoice ?? true,
    isShowElement: documentModel.template.documentName.isShowElement,
    value: HandleDocumentNameAbb(
      documentModel,
      documentModel.headerOptionType,
      documentModel.document.data.isTaxInvoice
    ),
    isTaxInvoice:
      documentModel.document.data.isTaxInvoice && documentModel.transactionType !== TransactionType.TaxInvoice,
  };

  if (settingDocumentTemplateDefault) {
    documentName.headerOptionName = settingDocumentTemplateDefault.documentName.headerOptionType;
    documentName.documentHeaderSize = settingDocumentTemplateDefault.documentName.documentHeaderSize;
    documentName.isShowElement = settingDocumentTemplateDefault.documentName.isShowElement;
    documentName.value = settingDocumentTemplateDefault.documentName.value;
    documentName.isShowTaxInvoice = settingDocumentTemplateDefault.documentName.isShowTaxInvoice;
    documentName.isShowNonTaxInvoice = settingDocumentTemplateDefault.documentName.isShowNonTaxInvoice;
  }

  return documentName;
}

export function HandleDocumentNameAbb(
  documentModel: OnlineViewModel,
  headerOptionType: ReceiptHeaderType,
  isTaxInvoice: boolean
) {
  let documentName = "";
  if (documentModel.transactionType === DocumentType.Receipt && headerOptionType === ReceiptHeaderType.AbbA4Header) {
    if (isTaxInvoice) {
      documentName = "TaxInvoiceAbb";
    } else {
      documentName = "ReceiptAbb";
    }
  } else {
    documentName = documentModel.template.documentName.value;
  }

  return documentName;
}

function GetDocumentControlNo(documentModel: OnlineViewModel) {
  let documentControlNo = {
    value: "",
    alignment: AlignmentDocumentControlNo.LeftFooter,
  };

  if (documentModel.template.documentControlNo) {
    documentControlNo.value = documentModel.template.documentControlNo.value;
    documentControlNo.alignment = documentModel.template.documentControlNo.alignment;
  }

  return documentControlNo;
}

function SetDocumentName(documentName: string, documentModel: OnlineViewModel) {
  let name = i18n.t(documentName).toString();

  if (documentModel.document.data.isTaxInvoice && documentModel.transactionType !== TransactionType.TaxInvoice) {
    name += "/" + i18n.t("TaxInvoice");
  }
  return name;
}

export function GetMerchant(
  documentModel: OnlineViewModel | JournalOnlineViewModel | PP30OnlineViewModel,
  settingDocumentTemplateDefault?:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
): ElementMerchantModel {
  const merchant: ElementMerchantModel = {
    isCustomTextDisplay: documentModel.template.merchant.isCustomTextDisplay ?? false,
    isShowTextHeadOffice: documentModel.template.merchant.isShowTextHeadOffice ?? true,
    isShowClassification: documentModel.template.merchant.isShowClassification ?? false,
    title: documentModel.template.merchant.merchantTitle.value,
    merchantClassificationList: documentModel.template.merchant.merchantClassificationList ?? [],
    merchantName: documentModel.document.data.merchant.name,
    merchantType: documentModel.document.data.merchant.merchantType,
    merchantAddress: ConvertToAddressDetail(documentModel.document.data.merchant),
    merchantAddressTemplate: documentModel.template.merchant.merchantAddressTemplate,
    merchantTaxId: documentModel.document.data.merchant.taxNumber,
    merchantBranchCode: documentModel.document.data.merchant.branchCode,
    phoneNumber: {
      value: GetValueBySettingOrDefault(
        documentModel.template.merchant.phoneNumber.value,
        documentModel.document.data.merchant.phoneNumber
      ),
      isShowElement: documentModel.template.merchant.phoneNumber.isShowElement,
    },
    email: {
      value: GetValueBySettingOrDefault(
        documentModel.template.merchant.email.value,
        documentModel.document.data.merchant.email
      ),
      isShowElement: documentModel.template.merchant.email.isShowElement,
    },
    website: {
      value: GetValueBySettingOrDefault(
        documentModel.template.merchant.website?.value,
        documentModel.document.data.merchant.website
      ),
      isShowElement: documentModel.template.merchant.website?.isShowElement ?? true,
    },
  };

  if (settingDocumentTemplateDefault) {
    merchant.isCustomTextDisplay = settingDocumentTemplateDefault.merchant.isCustomTextDisplay ?? false;
    merchant.isShowClassification = settingDocumentTemplateDefault.merchant.isShowClassification ?? false;
    merchant.isShowTextHeadOffice = settingDocumentTemplateDefault.merchant.isShowTextHeadOffice ?? true;
    merchant.merchantClassificationList = settingDocumentTemplateDefault.merchant.merchantClassificationList ?? [];

    merchant.title = settingDocumentTemplateDefault.merchant.merchantTitle.value;
    merchant.merchantAddressTemplate = settingDocumentTemplateDefault.merchant.merchantAddressTemplate;
    merchant.phoneNumber = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.merchant.phoneNumber.value,
        documentModel.document.data.merchant.phoneNumber
      ),
      isShowElement: settingDocumentTemplateDefault.merchant.phoneNumber.isShowElement,
    };
    merchant.email = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.merchant.email.value,
        documentModel.document.data.merchant.email
      ),
      isShowElement: settingDocumentTemplateDefault.merchant.email.isShowElement,
    };
    merchant.website = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.merchant.website?.value,
        documentModel.document.data.merchant.website
      ),
      isShowElement: settingDocumentTemplateDefault.merchant.website?.isShowElement ?? true,
    };
  }
  return merchant;
}
export function GetContact(
  documentModel: OnlineViewModel | JournalOnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel | SettingJournalDocumentTemplateModel
): ElementContactModel {
  const contact: ElementContactModel = {
    isShowContact: documentModel.template.contact.isShowContact,
    isCustomTextDisplay: documentModel.template.contact.isCustomTextDisplay,
    isShowTextHeadOffice: documentModel.template.contact.isShowTextHeadOffice ?? true,
    isShowClassification: documentModel.template.contact.isShowClassification ?? false,
    contactClassificationList: documentModel.template.contact.contactClassificationList ?? [],
    contactTitle: documentModel.template.contact.contactTitle.value,
    dearTitle: {
      value: documentModel.template.contact.dearTitle.value ? documentModel.template.contact.dearTitle.value : "",
      isShowElement: documentModel.template.contact.dearTitle.isShowElement,
    },
    contactName: documentModel.document.data.contact.name,
    isOrdinaryPerson: documentModel.document.data.contact.isOrdinaryPerson,
    contactOrdinaryPerson: documentModel.document.data.contact.ordinaryPerson,
    contactMerchantType: documentModel.document.data.contact.merchantType,
    contactCode: {
      value: documentModel.document.data.contact.contactCode,
      isShowElement: documentModel.template.contact.isShowContactCode,
    },
    contactAddress: GetAddress(documentModel.document.data.contact),
    contactTaxId: documentModel.document.data.contact.taxNumber,
    contactBranchCode: documentModel.document.data.contact.branchCode,
    ordinaryPerson: documentModel.document.data.contact.person.ordinaryPerson ?? OrdinaryPersonPrefixType.None,
    dearName: `${documentModel.document.data.contact.person.firstName ?? ""} ${
      documentModel.document.data.contact.person.lastName ?? ""
    }`,
    phoneNumber: {
      value: GetValueBySettingOrDefault(
        documentModel.template.contact.phoneNumber.value,
        documentModel.document.data.contact.phoneNumber
      ),
      isShowElement: documentModel.template.contact.phoneNumber.isShowElement,
    },
    email: {
      value: GetValueBySettingOrDefault(
        documentModel.template.contact.email.value,
        documentModel.document.data.contact.email
      ),
      isShowElement: documentModel.template.contact.email.isShowElement,
    },
    website: {
      value: GetValueBySettingOrDefault(
        documentModel.template.contact.website?.value,
        documentModel.document.data.contact.website
      ),
      isShowElement: documentModel.template.contact.website?.isShowElement ?? true,
    },
  };

  if (settingDocumentTemplateDefault) {
    contact.isShowContact = settingDocumentTemplateDefault.contact.isShowContact;
    contact.isCustomTextDisplay = settingDocumentTemplateDefault.contact.isCustomTextDisplay;
    contact.isShowTextHeadOffice = settingDocumentTemplateDefault.contact.isShowTextHeadOffice ?? true;
    contact.isShowClassification = settingDocumentTemplateDefault.contact.isShowClassification ?? false;
    contact.contactClassificationList = documentModel.template.contact.contactClassificationList ?? [];
    contact.contactTitle = settingDocumentTemplateDefault.contact.contactTitle.value;
    contact.dearTitle = {
      value: settingDocumentTemplateDefault.contact.dearTitle.value
        ? settingDocumentTemplateDefault.contact.dearTitle.value
        : "",
      isShowElement: settingDocumentTemplateDefault.contact.dearTitle.isShowElement,
    };
    contact.contactCode = {
      value: documentModel.document.data.contact.contactCode,
      isShowElement: settingDocumentTemplateDefault.contact.isShowContactCode,
    };
    contact.phoneNumber = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.contact.phoneNumber.value,
        documentModel.document.data.contact.phoneNumber
      ),
      isShowElement: settingDocumentTemplateDefault.contact.phoneNumber.isShowElement,
    };
    contact.email = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.contact.email.value,
        documentModel.document.data.contact.email
      ),
      isShowElement: settingDocumentTemplateDefault.contact.email.isShowElement,
    };
    contact.website = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.contact.website?.value,
        documentModel.document.data.contact.website
      ),
      isShowElement: settingDocumentTemplateDefault.contact.website?.isShowElement ?? true,
    };
  }
  return contact;
}

export function GetDocumentInfo(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementDocumentInfoModel {
  const documentInfo: ElementDocumentInfoModel = {
    documentNoTitle: {
      value: documentModel.template.documentInfo.documentNoTitle.value,
      isShowElement: documentModel.template.documentInfo.documentNoTitle.isShowElement,
    },
    issedDateTitle: {
      value: documentModel.template.documentInfo.issedDateTitle.value,
      isShowElement: documentModel.template.documentInfo.issedDateTitle.isShowElement,
    },
    creditTitle: {
      value: documentModel.template.documentInfo.creditTitle.value,
      isShowElement: documentModel.template.documentInfo.creditTitle.isShowElement,
    },
    acceptedDateTitle: {
      value: documentModel.template.documentInfo.acceptedDateTitle.value,
      isShowElement: documentModel.template.documentInfo.acceptedDateTitle.isShowElement,
    },
    rejectedDateTitle: GetRejectedDateTitle(documentModel.template.documentInfo.rejectedDateTitle),
    dueDateTitle: {
      value: documentModel.template.documentInfo.dueDateTitle.value,
      isShowElement: documentModel.template.documentInfo.dueDateTitle.isShowElement,
    },
    refTitle: {
      value: documentModel.template.documentInfo.refTitle.value,
      isShowElement: documentModel.template.documentInfo.refTitle.isShowElement,
    },
    taxInvoiceNumberTitle: {
      value: documentModel.template.documentInfo.taxInvoiceNumberTitle.value,
      isShowElement: documentModel.template.documentInfo.taxInvoiceNumberTitle.isShowElement,
    },
    taxInvoiceDateTimeTitle: {
      value: documentModel.template.documentInfo.taxInvoiceDateTimeTitle.value,
      isShowElement: documentModel.template.documentInfo.taxInvoiceDateTimeTitle.isShowElement,
    },
    isCustomTextDisplay: documentModel.template.documentInfo.isCustomTextDisplay,
    dateOptionType: documentModel.template.documentInfo.dateOptionType,
    documentNo: documentModel.document.data.transactionNumber,
    issedDate: new Date(documentModel.document.data.issuedDateTime),
    isShowIssueDateValue: documentModel.template.documentInfo.isShowIssueDateValue ?? true,
    credit: GetCredit(documentModel.document.data.issuedDateTime, documentModel.document.data.dueDateTime),
    acceptedDate: new Date(documentModel.document.data.acceptedDateTime),
    rejectedDate: new Date(documentModel.document.data.rejectedDateTime),
    dueDate: new Date(documentModel.document.data.dueDateTime),
    ref: documentModel.document.data.reference.text ? documentModel.document.data.reference.text : "-",
    taxInvoiceNumber: documentModel.document.data.purchaseTaxInvoices.taxInvoiceNumber
      ? documentModel.document.data.purchaseTaxInvoices.taxInvoiceNumber
      : "-",
    taxInvoiceDateTime: new Date(documentModel.document.data.purchaseTaxInvoices.taxInvoiceDateTime),
    isShowClassification: documentModel.template.documentInfo.isShowClassification ?? false,
    documentInfoClassificationList: documentModel.template.documentInfo.documentInfoClassificationList ?? [],
  };

  if (settingDocumentTemplateDefault) {
    documentInfo.documentNoTitle = {
      value: settingDocumentTemplateDefault.documentInfo.documentNoTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.documentNoTitle.isShowElement,
    };
    documentInfo.issedDateTitle = {
      value: settingDocumentTemplateDefault.documentInfo.issedDateTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.issedDateTitle.isShowElement,
    };
    documentInfo.creditTitle = {
      value: settingDocumentTemplateDefault.documentInfo.creditTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.creditTitle.isShowElement,
    };
    documentInfo.acceptedDateTitle = {
      value: settingDocumentTemplateDefault.documentInfo.acceptedDateTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.acceptedDateTitle.isShowElement,
    };
    documentInfo.rejectedDateTitle = GetRejectedDateTitle(
      settingDocumentTemplateDefault.documentInfo.rejectedDateTitle
    );
    documentInfo.dueDateTitle = {
      value: settingDocumentTemplateDefault.documentInfo.dueDateTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.dueDateTitle.isShowElement,
    };
    documentInfo.refTitle = {
      value: settingDocumentTemplateDefault.documentInfo.refTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.refTitle.isShowElement,
    };
    documentInfo.taxInvoiceNumberTitle = {
      value: settingDocumentTemplateDefault.documentInfo.taxInvoiceNumberTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.taxInvoiceNumberTitle.isShowElement,
    };
    documentInfo.taxInvoiceDateTimeTitle = {
      value: settingDocumentTemplateDefault.documentInfo.taxInvoiceDateTimeTitle.value,
      isShowElement: settingDocumentTemplateDefault.documentInfo.taxInvoiceDateTimeTitle.isShowElement,
    };
    documentInfo.isCustomTextDisplay = settingDocumentTemplateDefault.documentInfo.isCustomTextDisplay;
    documentInfo.dateOptionType = settingDocumentTemplateDefault.documentInfo.dateOptionType;
    documentInfo.isShowIssueDateValue = settingDocumentTemplateDefault.documentInfo.isShowIssueDateValue;
    documentInfo.isShowClassification = settingDocumentTemplateDefault.documentInfo.isShowClassification;
    documentInfo.documentInfoClassificationList =
      settingDocumentTemplateDefault.documentInfo.documentInfoClassificationList;
  }
  return documentInfo;
}
function GetCredit(issuedDateTime: any, dueDateTime: any) {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const firstDate: any = new Date(issuedDateTime);
  const secondDate: any = new Date(dueDateTime);
  const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
  return diffDays;
}

function GetRejectedDateTitle(rejectedDateTitle: any) {
  const rejectedDate = !rejectedDateTitle
    ? {
        value: "Rejected_Date",
        isShowElement: true,
      }
    : {
        value: rejectedDateTitle.value,
        isShowElement: rejectedDateTitle.isShowElement,
      };

  return rejectedDate;
}

export function GetMerchantPerson(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementMerchantPersonModel {
  const merchantPerson: ElementMerchantPersonModel = {
    isShowMerchantPerson: documentModel.template.merchantPerson.isShowMerchantPerson,
    merchantPersonTitle: {
      value: documentModel.template.merchantPerson.merchantPersonTitle.value,
      isShowElement: documentModel.template.merchantPerson.merchantPersonTitle.isShowElement,
    },
    merchantName: {
      isShowElement: documentModel.template.merchantPerson.merchantTitle.isShowElement,
      value: `${documentModel.document.data.merchant.user.firstName ?? ""} ${
        documentModel.document.data.merchant.user.lastName ?? ""
      }`,
    },
    phoneNumber: {
      value: GetValueBySettingOrDefault(
        documentModel.template.merchantPerson.phoneNumber.value,
        documentModel.document.data.merchant.user.phoneNumber
      ),
      isShowElement: documentModel.template.merchantPerson.phoneNumber.isShowElement,
    },
    email: {
      value: GetValueBySettingOrDefault(
        documentModel.template.merchantPerson.email.value,
        documentModel.document.data.merchant.user.email
      ),
      isShowElement: documentModel.template.merchantPerson.email.isShowElement,
    },
    isCustomTextDisplay: documentModel.template.merchantPerson.isCustomTextDisplay,
  };

  if (settingDocumentTemplateDefault) {
    merchantPerson.isShowMerchantPerson = settingDocumentTemplateDefault.merchantPerson.isShowMerchantPerson;
    merchantPerson.merchantPersonTitle = {
      value: settingDocumentTemplateDefault.merchantPerson.merchantPersonTitle.value,
      isShowElement: settingDocumentTemplateDefault.merchantPerson.merchantPersonTitle.isShowElement,
    };
    merchantPerson.merchantName.isShowElement =
      settingDocumentTemplateDefault.merchantPerson.merchantTitle.isShowElement;
    merchantPerson.phoneNumber = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.merchantPerson.phoneNumber.value,
        documentModel.document.data.merchant.user.phoneNumber
      ),
      isShowElement: settingDocumentTemplateDefault.merchantPerson.phoneNumber.isShowElement,
    };
    merchantPerson.email = {
      value: GetValueBySettingOrDefault(
        settingDocumentTemplateDefault.merchantPerson.email.value,
        documentModel.document.data.merchant.user.email
      ),
      isShowElement: documentModel.template.merchantPerson.email.isShowElement,
    };
    merchantPerson.isCustomTextDisplay = settingDocumentTemplateDefault.merchantPerson.isCustomTextDisplay;
  }

  return merchantPerson;
}

export function GetSettingColumn(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementSettigColumnModel {
  const settingColumn: ElementSettigColumnModel = {
    isShowAmount: documentModel.template.settingColumn.isShowAmount,
    isShowUnit: documentModel.template.settingColumn.isShowUnit,
    isShowPrice: documentModel.template.settingColumn.isShowPrice,
    isShowDiscount: documentModel.template.settingColumn.isShowDiscount,
    isShowVatAmount: documentModel.template.settingColumn.isShowVatAmount,
    isShowPreVatAmount: documentModel.template.settingColumn.isShowPreVatAmount,
    isShowIncVatAmount: documentModel.template.settingColumn.isShowIncVatAmount ?? false,
    isShowWhtAmount: documentModel.template.settingColumn.isShowWhtAmount,
    isShowBilledAmount: documentModel.template.settingColumn.isShowBilledAmount,
    isShowDocumentNumber: documentModel.template.settingColumn.isShowDocumentNumber,
    isShowDueDate: documentModel.template.settingColumn.isShowDueDate,
    isShowIssedDate: documentModel.template.settingColumn.isShowIssedDate,
    isShowProductItems: documentModel.template.settingColumn.isShowProductItems,
    isShowTaxInvoiceNo: documentModel.template.settingColumn.isShowTaxInvoiceNo ?? true,
  };
  if (settingDocumentTemplateDefault) {
    settingColumn.isShowAmount = settingDocumentTemplateDefault.settingColumn.isShowAmount;
    settingColumn.isShowUnit = settingDocumentTemplateDefault.settingColumn.isShowUnit;
    settingColumn.isShowPrice = settingDocumentTemplateDefault.settingColumn.isShowPrice;
    settingColumn.isShowDiscount = settingDocumentTemplateDefault.settingColumn.isShowDiscount;
    settingColumn.isShowVatAmount = settingDocumentTemplateDefault.settingColumn.isShowVatAmount;
    settingColumn.isShowPreVatAmount = settingDocumentTemplateDefault.settingColumn.isShowPreVatAmount;
    settingColumn.isShowIncVatAmount = settingDocumentTemplateDefault.settingColumn.isShowIncVatAmount;
    settingColumn.isShowWhtAmount = settingDocumentTemplateDefault.settingColumn.isShowWhtAmount;
    settingColumn.isShowBilledAmount = settingDocumentTemplateDefault.settingColumn.isShowBilledAmount;
    settingColumn.isShowDocumentNumber = settingDocumentTemplateDefault.settingColumn.isShowDocumentNumber;
    settingColumn.isShowDueDate = settingDocumentTemplateDefault.settingColumn.isShowDueDate;
    settingColumn.isShowIssedDate = settingDocumentTemplateDefault.settingColumn.isShowIssedDate;
    settingColumn.isShowProductItems = settingDocumentTemplateDefault.settingColumn.isShowProductItems;
    settingColumn.isShowTaxInvoiceNo = settingDocumentTemplateDefault.settingColumn.isShowTaxInvoiceNo;
  }
  return settingColumn;
}
export function GetSettingDescription(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementSettigDescriptionModel {
  const settingDescription: ElementSettigDescriptionModel = {
    isShowCode: documentModel.template.settingDescription.isShowCode,
    isShowDescription: documentModel.template.settingDescription.isShowDescription,
    isShowImage: documentModel.template.settingDescription.isShowImage,
    isShowName: documentModel.template.settingDescription.isShowName,
  };

  if (settingDocumentTemplateDefault) {
    settingDescription.isShowCode = settingDocumentTemplateDefault.settingDescription.isShowCode;
    settingDescription.isShowDescription = settingDocumentTemplateDefault.settingDescription.isShowDescription;
    settingDescription.isShowImage = settingDocumentTemplateDefault.settingDescription.isShowImage;
    settingDescription.isShowName = settingDocumentTemplateDefault.settingDescription.isShowName;
  }
  return settingDescription;
}

function GetVatType(vatType: ProductVatType) {
  let vat = "-";
  switch (vatType) {
    case ProductVatType.None:
      vat = "None";
      break;
    case ProductVatType.ZeroPercent:
      vat = "0%";
      break;
    case ProductVatType.SevenPercent:
      vat = "7%";
      break;
  }

  return vat;
}

export function GetWhtAmount(
  wht: DocumentWhtModel,
  currency: DocumentCurrencyModel | CurrencyDetailModel,
  settingCurrency: CurrencyCode
) {
  let whtAmount = "-";
  switch (wht.whtAmountType) {
    case WhtAmountType.Custom:
      whtAmount = CalculateWithSettingCurrency(wht.whtAmount, currency, settingCurrency).FormatMoney();
      break;
    case WhtAmountType.None:
      whtAmount = "None";
      break;
    case WhtAmountType.NotSpecify:
      whtAmount = "-";
      break;
    case WhtAmountType.FifteenPercent:
    case WhtAmountType.FivePercent:
    case WhtAmountType.OnePercent:
    case WhtAmountType.OnePointFivePercent:
    case WhtAmountType.TenPercent:
    case WhtAmountType.ThreePercent:
    case WhtAmountType.TwoPercent:
    case WhtAmountType.ZeroPointSevenFive:
      whtAmount = CalculateWithSettingCurrency(wht.whtAmount, currency, settingCurrency).FormatMoney();
      break;
  }

  return whtAmount;
}

export function GetBillingList(documentModel: OnlineViewModel): Array<ElementBillingItemModel> {
  const billingList = new Array<ElementBillingItemModel>();
  const itemstList = documentModel.document.data.billing;

  if (itemstList && itemstList.length > 0) {
    const currencyDetail: CurrencyDetailModel = {
      exchangeRates: documentModel.document.data.billing[0].document.exchangeRates,
      exchangeRatioType: documentModel.document.data.billing[0].document.exchangeRatioType,
      fromCurrency: documentModel.document.data.currency.fromCurrency,
      toCurrency: documentModel.document.data.currency.toCurrency,
      settingCurrency: documentModel.template.settingCurrency,
    };
    itemstList.forEach((element, index) => {
      billingList.push({
        index: index,
        billedAmount: element.billedAmount,
        billedCurrencyAmount: element.billedCurrencyAmount,
        description: element.description,
        document: element.document,
        isDescriptionOnly: element.isDescriptionOnly,
        itemId: element.itemId,
        sequenceNumber: element.sequenceNumber,
        wht: GetWhtAmount(element.wht, currencyDetail, documentModel.template.settingCurrency),
        productItems: element.items ? GetBillingListProductItemList(element.items, documentModel, currencyDetail) : [],
        taxInvoiceNumber:
          element.purchaseTaxInvoices && element.purchaseTaxInvoices.length > 0
            ? element.purchaseTaxInvoices[0].taxInvoiceNumber
            : "-",
        isHasProductItems: element.items && element.items.length > 0,
      });
    });
  }

  return billingList;
}

export function GetBillingListProductItemList(
  itemList: Array<DocumentItemBaseModel>,
  documentModel: OnlineViewModel,
  currencyDetail: CurrencyDetailModel
): Array<ElementBillingNoteProductItemModel> {
  const productItems = itemList.map((element) => {
    const productItem = new ElementBillingNoteProductItemModel();
    productItem.sequenceNumber = element.sequenceNumber;
    productItem.productName = element.product.name;
    productItem.accountName = element.account.name;
    productItem.accountNameEn = element.account.nameEn;
    productItem.productDescription = element.description;
    productItem.productCode = element.product.productCode;
    productItem.accountCode = element.account.accountCode;
    productItem.vatType = GetVatType(element.vatType);
    productItem.preVatAmount = CalculateWithSettingCurrency(
      element.subTotal,
      documentModel.document.data.currency,
      documentModel.template.settingCurrency
    );
    productItem.quantity = element.quantity;
    productItem.pricePerItem = CalculateWithSettingCurrency(
      element.price,
      documentModel.document.data.currency,
      documentModel.template.settingCurrency
    );
    productItem.whtAmount = GetWhtAmount(element.wht, currencyDetail, documentModel.template.settingCurrency);
    return productItem;
  });
  return productItems;
}

export function GetPricePerItem(
  quantity: number,
  subTotal: number,
  currency: DocumentCurrencyModel | CurrencyDetailModel,
  settingCurrency: CurrencyCode
): number {
  const pricePerItem = CalculateWithSettingCurrency(subTotal, currency, settingCurrency).Divide(quantity);
  return pricePerItem;
}

export function GetProductList(documentModel: OnlineViewModel): Array<ElementProductItemModel> {
  const productList = new Array<ElementProductItemModel>();
  const itemstList = documentModel.document.data.items;

  if (itemstList && itemstList.length > 0) {
    itemstList.forEach((element, index) => {
      const productItem: ElementProductItemModel = {
        index: index,
        isDescriptionOnly: element.isDescriptionOnly,
        sequenceNumber: element.sequenceNumber,
        productUrl: "",
        productName: element.product.name,
        productCode: element.product.productCode,
        accountName: element.account.name,
        accountNameEn: element.account.nameEn,
        accountCode: element.account.accountCode,
        quantity: element.quantity,
        unit: element.unit.name ? element.unit.name : "-",
        unitEn: element.unit.nameEn ? element.unit.nameEn : "-",
        description: element.description,
        price: CalculateWithSettingCurrency(
          element.price,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        discount:
          element.discount.discountType == DiscountType.Amount
            ? CalculateWithSettingCurrency(
                element.discount.discountAmount,
                documentModel.document.data.currency,
                documentModel.template.settingCurrency
              ).ToPeakTransactionItemFormat()
            : element.discount.discountAmount.ToPeakTransactionItemFormat() + "%",
        vatType: GetVatType(element.vatType),
        preVatAmount: CalculateWithSettingCurrency(
          element.subTotal,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        incVatAmount: CalculateWithSettingCurrency(
          element.incVat,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        whtAmount: GetWhtAmount(
          element.wht,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        productImages: element.product.productImages,
      };

      productList.push(productItem);
    });
  }

  return productList;
}

export function GetAssetGroupList(documentModel: OnlineViewModel): Array<ElementAssetGroupItemModel> {
  const assetGroupList = new Array<ElementAssetGroupItemModel>();
  const itemstList = documentModel.document.data.assetGroups;

  if (itemstList && itemstList.length > 0) {
    itemstList.forEach((element, index) => {
      const assetGroupItem: ElementAssetGroupItemModel = {
        index: index,
        isDescriptionOnly: element.isDescriptionOnly,
        sequenceNumber: element.sequenceNumber,
        quantity: element.quantity,
        description: element.description,
        price: CalculateWithSettingCurrency(
          element.price,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        unit: element.unit.name ? element.unit.name : "-",
        unitEn: element.unit.nameEn ? element.unit.nameEn : "-",
        discount:
          element.discount.discountType == DiscountType.Amount
            ? CalculateWithSettingCurrency(
                element.discount.discountAmount,
                documentModel.document.data.currency,
                documentModel.template.settingCurrency
              ).ToPeakTransactionItemFormat()
            : element.discount.discountAmount.ToPeakTransactionItemFormat() + "%",
        vatType: GetVatType(element.vatType),
        preVatAmount: CalculateWithSettingCurrency(
          element.subTotal,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        incVatAmount: CalculateWithSettingCurrency(
          element.incVat,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        whtAmount: GetWhtAmount(
          element.wht,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        assetGroupCode: element.assetGroup.assetGroupCode,
        name: element.assetGroup.name,
        nameEn: element.assetGroup.nameEn,
      };
      assetGroupList.push(assetGroupItem);
    });
  }
  return assetGroupList;
}

export function GetAssetList(documentModel: OnlineViewModel): Array<ElementAssetItemModel> {
  const assetList = new Array<ElementAssetItemModel>();
  const itemstList = documentModel.document.data.assets;

  if (itemstList && itemstList.length > 0) {
    itemstList.forEach((element, index) => {
      const assetItem: ElementAssetItemModel = {
        index: index,
        isDescriptionOnly: element.isDescriptionOnly,
        sequenceNumber: element.sequenceNumber,
        quantity: element.quantity,
        description: element.description,
        price: CalculateWithSettingCurrency(
          element.price,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        unit: element.unit.name ? element.unit.name : "-",
        unitEn: element.unit.nameEn ? element.unit.nameEn : "-",
        discount:
          element.discount.discountType == DiscountType.Amount
            ? CalculateWithSettingCurrency(
                element.discount.discountAmount,
                documentModel.document.data.currency,
                documentModel.template.settingCurrency
              ).ToPeakTransactionItemFormat()
            : element.discount.discountAmount.ToPeakTransactionItemFormat() + "%",
        vatType: GetVatType(element.vatType),
        preVatAmount: CalculateWithSettingCurrency(
          element.subTotal,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        incVatAmount: CalculateWithSettingCurrency(
          element.incVat,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        whtAmount: GetWhtAmount(
          element.wht,
          documentModel.document.data.currency,
          documentModel.template.settingCurrency
        ),
        assetGroupCode: element.assetGroup.assetGroupCode,
        name: element.assetGroup.name,
        nameEn: element.assetGroup.nameEn,
        assetCode: element.asset.assetCode,
      };
      assetList.push(assetItem);
    });
  }
  return assetList;
}

export function GetExpenseClaimDetail(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementExpenseClaimDetailModel {
  const expenseClaim: ElementExpenseClaimDetailModel = {
    idCard: {
      value: documentModel.template.expenseClaimDetail.idCard.value,
      isShowElement: documentModel.template.expenseClaimDetail.idCard.isShowElement,
    },
    expenseClaimNote: {
      value: documentModel.template.expenseClaimDetail.expenseClaimNote.value,
      isShowElement: documentModel.template.expenseClaimDetail.expenseClaimNote.isShowElement,
    },
  };

  if (settingDocumentTemplateDefault) {
    expenseClaim.idCard = {
      value: settingDocumentTemplateDefault.expenseClaimDetail.idCard.value,
      isShowElement: settingDocumentTemplateDefault.expenseClaimDetail.idCard.isShowElement,
    };
    expenseClaim.expenseClaimNote = {
      value: settingDocumentTemplateDefault.expenseClaimDetail.expenseClaimNote.value,
      isShowElement: settingDocumentTemplateDefault.expenseClaimDetail.expenseClaimNote.isShowElement,
    };
  }
  return expenseClaim;
}

export function GetCertified(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementCertifiedModel {
  let certified: ElementCertifiedModel = new ElementCertifiedModel();
  certified = {
    userCreateTitle: {
      value: documentModel.template.certified.userCreateTitle.value,
      isShowElement: documentModel.template.certified.userCreateTitle.isShowElement,
    },
    userApproveTitle: {
      value: documentModel.template.certified.userApproveTitle.value,
      isShowElement: documentModel.template.certified.userApproveTitle.isShowElement,
    },
    merchantStampTitle: {
      value: documentModel.template.certified.merchantStampTitle.value,
      isShowElement: documentModel.template.certified.merchantStampTitle.isShowElement,
    },
    receivedByTitle: {
      value: documentModel.template.certified.receivedByTitle.value,
      isShowElement: documentModel.template.certified.receivedByTitle.isShowElement,
    },
    stampTitle: {
      value: documentModel.template.certified.stampTitle.value,
      isShowElement: documentModel.template.certified.stampTitle.isShowElement,
    },
    userAcceptTitle: GetUserAcceptTitle(documentModel.template.certified.userAcceptTitle),
    userApprove: {
      isShowSignatureUrl: documentModel.template.certified.isShowUserApproveUrl ?? true,
      isShowApproveDate: documentModel.template.certified.isShowUserApproveDate ?? true,
      isShowApproveName: documentModel.template.certified.isShowUserApproveName ?? true,
      approveDate: AddHours(new Date(documentModel.document.data.approvedDateTime), thailandTimeZone),
      name:
        documentModel.document.data.approvedUser.firstName + " " + documentModel.document.data.approvedUser.lastName,
      signatureUrl: GetSignatureUrlUserApprove(documentModel),
    },
    userCreate: {
      isShowSignatureUrl: documentModel.template.certified.isShowUserCreateUrl ?? true,
      isShowCreateDate: documentModel.template.certified.isShowUserCreateDate ?? true,
      isShowCreateName: documentModel.template.certified.isShowUserCreateName ?? true,
      createDate: AddHours(new Date(documentModel.document.data.createdDateTime), thailandTimeZone),
      name: documentModel.document.data.createdUser.firstName + " " + documentModel.document.data.createdUser.lastName,
      signatureUrl: GetSignatureUrlUserCreate(documentModel),
    },
    userAccept: {
      isShowSignatureUrl: documentModel.template.certified.isShowUserAcceptUrl ?? true,
      isShowAcceptDate: documentModel.template.certified.isShowUserAcceptDate ?? true,
      isShowAcceptName: documentModel.template.certified.isShowUserAcceptName ?? true,
      acceptDate: AddHours(new Date(documentModel.document.data.acceptedDateTime), thailandTimeZone),
      name:
        documentModel.document.data.acceptedUser.firstName + " " + documentModel.document.data.acceptedUser.lastName,
      signatureUrl: GetSignatureUrlUserAccept(documentModel),
    },
    userReject: {
      isShowSignatureUrl: documentModel.template.certified.isShowUserAcceptUrl ?? true,
      isShowAcceptDate: documentModel.template.certified.isShowUserAcceptDate ?? true,
      isShowAcceptName: documentModel.template.certified.isShowUserAcceptName ?? true,
      rejectDate: AddHours(new Date(documentModel.document.data.rejectedDateTime), thailandTimeZone),
      name:
        documentModel.document.data.rejectedUser.firstName + " " + documentModel.document.data.rejectedUser.lastName,
      signatureUrl: GetSignatureUrlUserReject(documentModel),
    },
    merchantStampUrl: {
      value: documentModel.credential.merchantCredential.stampUrl,
      isShowElement: documentModel.template.certified.isShowMerchantStampUrl,
    },
    userCustomer: {
      isShowUserCustomerName: documentModel.template.certified.isShowUserCustomerName ?? true,
    },
    isCustomTextDisplay: documentModel.template.certified.isCustomTextDisplay,
    isShowQRCode: documentModel.template.certified.isShowQRCode ?? true,
    settingCreateDate: documentModel.template.certified.settingCreateDate ?? SettingCertifiedDate.ByDefaultDate,
    settingApproveDate: documentModel.template.certified.settingApproveDate ?? SettingCertifiedDate.ByDefaultDate,
    settingAcceptDate: documentModel.template.certified.settingAcceptDate ?? SettingCertifiedDate.ByDefaultDate,
  };

  if (settingDocumentTemplateDefault) {
    certified = {
      userCreateTitle: {
        value: settingDocumentTemplateDefault.certified.userCreateTitle.value,
        isShowElement: settingDocumentTemplateDefault.certified.userCreateTitle.isShowElement,
      },
      userApproveTitle: {
        value: settingDocumentTemplateDefault.certified.userApproveTitle.value,
        isShowElement: settingDocumentTemplateDefault.certified.userApproveTitle.isShowElement,
      },
      merchantStampTitle: {
        value: settingDocumentTemplateDefault.certified.merchantStampTitle.value,
        isShowElement: settingDocumentTemplateDefault.certified.merchantStampTitle.isShowElement,
      },
      receivedByTitle: {
        value: settingDocumentTemplateDefault.certified.receivedByTitle.value,
        isShowElement: settingDocumentTemplateDefault.certified.receivedByTitle.isShowElement,
      },
      stampTitle: {
        value: settingDocumentTemplateDefault.certified.stampTitle.value,
        isShowElement: settingDocumentTemplateDefault.certified.stampTitle.isShowElement,
      },
      userAcceptTitle: GetUserAcceptTitle(documentModel.template.certified.userAcceptTitle),
      userApprove: {
        isShowSignatureUrl: settingDocumentTemplateDefault.certified.isShowUserApproveUrl,
        isShowApproveDate: settingDocumentTemplateDefault.certified.isShowUserApproveDate,
        isShowApproveName: settingDocumentTemplateDefault.certified.isShowUserApproveName,
        approveDate: AddHours(new Date(documentModel.document.data.approvedDateTime), thailandTimeZone),
        name:
          documentModel.document.data.approvedUser.firstName + " " + documentModel.document.data.approvedUser.lastName,
        signatureUrl: GetSignatureUrlUserApprove(documentModel),
      },
      userCreate: {
        isShowSignatureUrl: settingDocumentTemplateDefault.certified.isShowUserCreateUrl,
        isShowCreateDate: settingDocumentTemplateDefault.certified.isShowUserCreateDate,
        isShowCreateName: settingDocumentTemplateDefault.certified.isShowUserCreateName,
        createDate: AddHours(new Date(documentModel.document.data.createdDateTime), thailandTimeZone),
        name:
          documentModel.document.data.createdUser.firstName + " " + documentModel.document.data.createdUser.lastName,
        signatureUrl: GetSignatureUrlUserCreate(documentModel),
      },
      userAccept: {
        isShowSignatureUrl: documentModel.template.certified.isShowUserAcceptUrl ?? true,
        isShowAcceptDate: documentModel.template.certified.isShowUserAcceptDate ?? true,
        isShowAcceptName: documentModel.template.certified.isShowUserAcceptName ?? true,
        acceptDate: AddHours(new Date(documentModel.document.data.acceptedDateTime), thailandTimeZone),
        name:
          documentModel.document.data.acceptedUser.firstName + " " + documentModel.document.data.acceptedUser.lastName,
        signatureUrl: GetSignatureUrlUserAccept(documentModel),
      },
      userReject: {
        isShowSignatureUrl: documentModel.template.certified.isShowUserAcceptUrl ?? true,
        isShowAcceptDate: documentModel.template.certified.isShowUserAcceptDate ?? true,
        isShowAcceptName: documentModel.template.certified.isShowUserAcceptName ?? true,
        rejectDate: AddHours(new Date(documentModel.document.data.rejectedDateTime), thailandTimeZone),
        name:
          documentModel.document.data.rejectedUser.firstName + " " + documentModel.document.data.rejectedUser.lastName,
        signatureUrl: GetSignatureUrlUserReject(documentModel),
      },
      userCustomer: {
        isShowUserCustomerName: documentModel.template.certified.isShowUserCustomerName ?? true,
      },
      merchantStampUrl: {
        value: documentModel.credential.merchantCredential.stampUrl,
        isShowElement: settingDocumentTemplateDefault.certified.isShowMerchantStampUrl,
      },
      isCustomTextDisplay: settingDocumentTemplateDefault.certified.isCustomTextDisplay,
      isShowQRCode: settingDocumentTemplateDefault.certified.isShowQRCode,
      settingCreateDate: settingDocumentTemplateDefault.certified.settingCreateDate,
      settingApproveDate: settingDocumentTemplateDefault.certified.settingApproveDate,
      settingAcceptDate: settingDocumentTemplateDefault.certified.settingAcceptDate,
    };
  }
  return certified;
}
export function AddHours(date: Date, hours: number) {
  const hoursToAdd = hours * 60 * 60 * 1000;
  date.setTime(date.getTime() + hoursToAdd);

  return date;
}

function GetUserAcceptTitle(userAcceptTitle: any) {
  const rejectedDate = !userAcceptTitle
    ? {
        value: "Accepted_By",
        isShowElement: true,
      }
    : {
        value: userAcceptTitle.value,
        isShowElement: userAcceptTitle.isShowElement,
      };

  return rejectedDate;
}

export function GetSignatureUrlUserCreate(
  documentModel:
    | OnlineViewModel
    | JournalOnlineViewModel
    | WitholdingTaxOnlineViewModel
    | PP30OnlineViewModel
    | PndOnlineViewModel
) {
  let userCreate = documentModel.credential.userCredential.find(
    (x) => x.userId === documentModel.document.data.createdUser.userId
  );
  if (userCreate) {
    return userCreate.signatureUrl;
  }
  return "";
}

export function GetSignatureUrlUserApprove(
  documentModel:
    | OnlineViewModel
    | JournalOnlineViewModel
    | WitholdingTaxOnlineViewModel
    | PP30OnlineViewModel
    | PndOnlineViewModel
) {
  let userApprove = documentModel.credential.userCredential.find(
    (x) => x.userId === documentModel.document.data.approvedUser.userId
  );
  if (userApprove) {
    return userApprove.signatureUrl;
  }
  return "";
}

export function GetSignatureUrlUserAccept(documentModel: OnlineViewModel) {
  let userAccept = documentModel.credential.userCredential.find(
    (x) => x.userId === documentModel.document.data.acceptedUser.userId
  );
  if (userAccept) {
    return userAccept.signatureUrl;
  }
  return "";
}

export function GetSignatureUrlUserReject(documentModel: OnlineViewModel) {
  let userAccept = documentModel.credential.userCredential.find(
    (x) => x.userId === documentModel.document.data.rejectedUser.userId
  );
  if (userAccept) {
    return userAccept.signatureUrl;
  }
  return "";
}

function GetIsShowDepositTitleDefault(transactionType: TransactionType): boolean {
  return transactionType == TransactionType.Receipt || transactionType == TransactionType.TaxInvoice;
}

export function GetAmountInfo(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementAmountInfoModel {
  const isUseCurrency = SetIsUseCurrency(
    documentModel.template.settingCurrency,
    documentModel.document.data.currency.toCurrency.currencyCode
  );

  const amountInfo: ElementAmountInfoModel = {
    amountInfoSettingType:
      documentModel.template.amountInfo.amountInfoSettingType ?? AmountInfoSettingType.NotDisplayCaseZero,
    isCustomTextDisplay: documentModel.template.amountInfo.isCustomTextDisplay ?? false,

    depositTitle: {
      value: documentModel.template.amountInfo.depositTitle?.value ?? "Deposit_Deduct",
      isShowElement:
        documentModel.template.amountInfo.depositTitle?.isShowElement ??
        GetIsShowDepositTitleDefault(documentModel.transactionType),
    },

    totalBeforeDeductTitle: {
      value: documentModel.template.amountInfo.totalBeforeDeductTitle?.value ?? "Total_Value_Before_Deduct",
      isShowElement: documentModel.template.amountInfo.totalBeforeDeductTitle?.isShowElement ?? false,
    },

    totalAfterDeductTitle: {
      value: documentModel.template.amountInfo.totalAfterDeductTitle?.value ?? "Total_Value_After_Deduct",
      isShowElement: documentModel.template.amountInfo.totalAfterDeductTitle?.isShowElement ?? false,
    },

    discountTitle: {
      value: documentModel.template.amountInfo.discountTitle.value,
      isShowElement: documentModel.template.amountInfo.discountTitle.isShowElement,
    },
    netAmountTitle: {
      value: documentModel.template.amountInfo.netAmountTitle.value,
      isShowElement: documentModel.template.amountInfo.netAmountTitle.isShowElement,
    },
    nonVATAmountTitle: {
      value: documentModel.template.amountInfo.nonVATAmountTitle.value,
      isShowElement: documentModel.template.amountInfo.nonVATAmountTitle.isShowElement,
    },
    preVATAmountTitle: {
      value: documentModel.template.amountInfo.preVATAmountTitle.value,
      isShowElement: documentModel.template.amountInfo.preVATAmountTitle.isShowElement,
    },
    vatAmountTitle: {
      value: documentModel.template.amountInfo.vatAmountTitle.value,
      isShowElement: documentModel.template.amountInfo.vatAmountTitle.isShowElement,
    },
    zeroVATAmountTitle: {
      value: documentModel.template.amountInfo.zeroVATAmountTitle.value,
      isShowElement: documentModel.template.amountInfo.zeroVATAmountTitle.isShowElement,
    },
    referenceTransactionAmountTitle: {
      value: documentModel.template.amountInfo.referenceTransactionAmountTitle
        ? documentModel.template.amountInfo.referenceTransactionAmountTitle.value
        : "",
      isShowElement: documentModel.template.amountInfo.referenceTransactionAmountTitle
        ? documentModel.template.amountInfo.referenceTransactionAmountTitle.isShowElement
        : false,
    },
    totalDocumentAmountAfterTitle: {
      value: documentModel.template.amountInfo.totalDocumentAmountAfterTitle
        ? documentModel.template.amountInfo.totalDocumentAmountAfterTitle.value
        : "",
      isShowElement: documentModel.template.amountInfo.totalDocumentAmountAfterTitle
        ? documentModel.template.amountInfo.totalDocumentAmountAfterTitle.isShowElement
        : false,
    },

    discount: GetTotalDiscountAmount(
      documentModel.document.data,
      isUseCurrency,
      GetDepositReferences(
        documentModel.document.data.deposit,
        documentModel.template.settingCurrency,
        isUseCurrency
      ).total.ToNumber()
    ).FormatMoney(),

    discountType: documentModel.document.data.discount.discountType,

    deposit: GetDepositReferences(
      documentModel.document.data.deposit,
      documentModel.template.settingCurrency,
      isUseCurrency
    ),

    totalBeforeDeductAmount: GetTotalBeforeDeductAmount(
      documentModel.document.data,
      isUseCurrency,
      GetDepositReferences(
        documentModel.document.data.deposit,
        documentModel.template.settingCurrency,
        isUseCurrency
      ).total.ToNumber()
    ).FormatMoney(),

    totalAfterDeductAmount: GetTotalAfterDeductAmount(
      documentModel.document.data,
      isUseCurrency,
      GetDepositReferences(
        documentModel.document.data.deposit,
        documentModel.template.settingCurrency,
        isUseCurrency
      ).total.ToNumber()
    ).ToPeakTransactionItemFormat(),

    netAmountTh: ConvertAmountToThaiWord(
      isUseCurrency
        ? documentModel.document.data.currency.netAmount.ToNumber()
        : documentModel.document.data.summary.netAmount.ToNumber(),
      documentModel.template.settingCurrency
    ),
    netAmountEn: ConvertAmountToEnglishWord(
      isUseCurrency
        ? documentModel.document.data.currency.netAmount.ToNumber()
        : documentModel.document.data.summary.netAmount.ToNumber(),
      documentModel.template.settingCurrency
    ),
    nonVATAmount: isUseCurrency
      ? documentModel.document.data.currency.vatExemptedTotal
      : documentModel.document.data.summary.vatExemptedTotal,
    preVATAmount: isUseCurrency
      ? documentModel.document.data.currency.preVatTotal
      : documentModel.document.data.summary.preVatTotal,
    vatAmount: isUseCurrency
      ? documentModel.document.data.currency.vatTotal
      : documentModel.document.data.summary.vatTotal,
    zeroVATAmount: isUseCurrency
      ? documentModel.document.data.currency.zeroVatTotal
      : documentModel.document.data.summary.zeroVatTotal,
    referenceTransactionAmount: documentModel.document.data.summaryDocumentModel.referenceTransactionAmount,
    totalDocumentAmountAfter: documentModel.document.data.summaryDocumentModel.totalDocumentAmountAfter,
  };

  if (settingDocumentTemplateDefault) {
    amountInfo.amountInfoSettingType = settingDocumentTemplateDefault.amountInfo.amountInfoSettingType;
    amountInfo.discountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.discountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.discountTitle.isShowElement,
    };
    amountInfo.netAmountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.netAmountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.netAmountTitle.isShowElement,
    };
    amountInfo.nonVATAmountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.nonVATAmountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.nonVATAmountTitle.isShowElement,
    };
    amountInfo.preVATAmountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.preVATAmountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.preVATAmountTitle.isShowElement,
    };
    amountInfo.vatAmountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.vatAmountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.vatAmountTitle.isShowElement,
    };
    amountInfo.zeroVATAmountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.zeroVATAmountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.zeroVATAmountTitle.isShowElement,
    };
    amountInfo.depositTitle = {
      value: settingDocumentTemplateDefault.amountInfo.depositTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.depositTitle.isShowElement,
    };
    amountInfo.totalBeforeDeductTitle = {
      value: settingDocumentTemplateDefault.amountInfo.totalBeforeDeductTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.totalBeforeDeductTitle.isShowElement,
    };
    amountInfo.totalAfterDeductTitle = {
      value: settingDocumentTemplateDefault.amountInfo.totalAfterDeductTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.totalAfterDeductTitle.isShowElement,
    };
    amountInfo.referenceTransactionAmountTitle = {
      value: settingDocumentTemplateDefault.amountInfo.referenceTransactionAmountTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.referenceTransactionAmountTitle.isShowElement,
    };
    amountInfo.totalDocumentAmountAfterTitle = {
      value: settingDocumentTemplateDefault.amountInfo.totalDocumentAmountAfterTitle.value,
      isShowElement: settingDocumentTemplateDefault.amountInfo.totalDocumentAmountAfterTitle.isShowElement,
    };
  }
  return amountInfo;
}

export function CheckIsShowElementDiscount(isShowElement: boolean, discountAmount: number) {
  return isShowElement ? (discountAmount == 0 ? false : true) : false;
}

export function CheckIsShowElementVatAmount(isShowElement: boolean, vatAmount: number) {
  return isShowElement ? (vatAmount == 0 ? false : true) : false;
}

export function CheckIsShowElementVATAmount(
  isShowElement: boolean,
  data: DocumentDataModel,
  productVatType: ProductVatType
) {
  let showElement = false;
  if (data.billing.length > 0) {
    switch (productVatType) {
      case ProductVatType.None:
        showElement = data.currency.vatExemptedTotal == 0 ? false : true;
        break;
      case ProductVatType.ZeroPercent:
        showElement = data.currency.zeroVatTotal == 0 ? false : true;
        break;
      case ProductVatType.SevenPercent:
        showElement = data.currency.preVatTotal == 0 ? false : true;
        break;
    }
  } else if (data.items.length > 0) {
    let isVAT = false;
    data.items.forEach((item) => {
      if (item.vatType == productVatType && !item.isDescriptionOnly) {
        isVAT = true;
      }
    });
    showElement = isVAT;
  } else if (data.assetGroups.length > 0) {
    let isVAT = false;
    data.assetGroups.forEach((item) => {
      if (item.vatType == productVatType && !item.isDescriptionOnly) {
        isVAT = true;
      }
    });
    showElement = isVAT;
  } else if (data.assets.length > 0) {
    let isVAT = false;
    data.assets.forEach((item) => {
      if (item.vatType == productVatType && !item.isDescriptionOnly) {
        isVAT = true;
      }
    });
    showElement = isVAT;
  }

  return showElement;
}

export function GetSummarizeInfo(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementSummarizeInfoModel {
  let defaultTemplate: SettingDocumentTemplateModel = GetDefaultSettingTemplateModel(
    documentModel.transactionType,
    documentModel.financeType,
    documentModel.expenseType,
    documentModel.headerOptionType,
    documentModel.document.data.isTaxInvoice,
    documentModel.document.data.currency.toCurrency.currencyCode
  );
  const isUseCurrency = SetIsUseCurrency(
    documentModel.template.settingCurrency,
    documentModel.document.data.currency.toCurrency.currencyCode
  );

  let summarizeInfo: ElementSummarizeInfoModel = new ElementSummarizeInfoModel();

  if (documentModel.template.summarizeInfo) {
    summarizeInfo = {
      isShowSummary: documentModel.template.summarizeInfo.isShowSummary ?? true,
      isCustomTextDisplay: documentModel.template.summarizeInfo.isCustomTextDisplay,
      positionSummarizeDefault: documentModel.template.summarizeInfo.positionSummarizeDefault,
      summaryAmountTitle: {
        value: documentModel.template.summarizeInfo.summaryAmountTitle.value,
        isShowElement: documentModel.template.summarizeInfo.summaryAmountTitle.isShowElement,
      },
      paymentAmountTitle: {
        value: documentModel.template.summarizeInfo.paymentAmountTitle.value,
        isShowElement: documentModel.template.summarizeInfo.paymentAmountTitle.isShowElement,
      },
      whtAmountTitle: {
        value: documentModel.template.summarizeInfo.whtAmountTitle.value,
        isShowElement: documentModel.template.summarizeInfo.whtAmountTitle.isShowElement,
      },
      summaryAmount: isUseCurrency
        ? documentModel.document.data.currency.netAmount
        : documentModel.document.data.summary.netAmount,
      paymentAmount: isUseCurrency
        ? documentModel.document.data.currency.netAmount - documentModel.document.data.currency.whtTotal
        : documentModel.document.data.summary.netAmount - documentModel.document.data.summary.whtTotal,
      whtAmount: isUseCurrency
        ? documentModel.document.data.currency.whtTotal
        : documentModel.document.data.summary.whtTotal,
    };
    if (settingDocumentTemplateDefault) {
      summarizeInfo = {
        isShowSummary: settingDocumentTemplateDefault.summarizeInfo.isShowSummary ?? true,
        isCustomTextDisplay: settingDocumentTemplateDefault.summarizeInfo.isCustomTextDisplay,
        positionSummarizeDefault: settingDocumentTemplateDefault.summarizeInfo.positionSummarizeDefault,
        summaryAmountTitle: {
          value: settingDocumentTemplateDefault.summarizeInfo.summaryAmountTitle.value,
          isShowElement: settingDocumentTemplateDefault.summarizeInfo.summaryAmountTitle.isShowElement,
        },
        paymentAmountTitle: {
          value: settingDocumentTemplateDefault.summarizeInfo.paymentAmountTitle.value,
          isShowElement: settingDocumentTemplateDefault.summarizeInfo.paymentAmountTitle.isShowElement,
        },
        whtAmountTitle: {
          value: settingDocumentTemplateDefault.summarizeInfo.whtAmountTitle.value,
          isShowElement: settingDocumentTemplateDefault.summarizeInfo.whtAmountTitle.isShowElement,
        },
        summaryAmount: isUseCurrency
          ? documentModel.document.data.currency.netAmount
          : documentModel.document.data.summary.netAmount,
        paymentAmount: isUseCurrency
          ? documentModel.document.data.currency.netAmount - documentModel.document.data.currency.whtTotal
          : documentModel.document.data.summary.netAmount - documentModel.document.data.summary.whtTotal,
        whtAmount: isUseCurrency
          ? documentModel.document.data.currency.whtTotal
          : documentModel.document.data.summary.whtTotal,
      };
    }
  } else {
    summarizeInfo = {
      isShowSummary: defaultTemplate.summarizeInfo.isShowSummary ?? true,
      isCustomTextDisplay: defaultTemplate.summarizeInfo.isCustomTextDisplay,
      positionSummarizeDefault: defaultTemplate.summarizeInfo.positionSummarizeDefault,
      summaryAmountTitle: {
        value: defaultTemplate.summarizeInfo.summaryAmountTitle.value,
        isShowElement: defaultTemplate.summarizeInfo.summaryAmountTitle.isShowElement,
      },
      paymentAmountTitle: {
        value: defaultTemplate.summarizeInfo.paymentAmountTitle.value,
        isShowElement: defaultTemplate.summarizeInfo.paymentAmountTitle.isShowElement,
      },
      whtAmountTitle: {
        value: defaultTemplate.summarizeInfo.whtAmountTitle.value,
        isShowElement: defaultTemplate.summarizeInfo.whtAmountTitle.isShowElement,
      },
      summaryAmount: isUseCurrency
        ? documentModel.document.data.currency.netAmount
        : documentModel.document.data.summary.netAmount,
      paymentAmount: isUseCurrency
        ? documentModel.document.data.currency.netAmount - documentModel.document.data.currency.whtTotal
        : documentModel.document.data.summary.netAmount - documentModel.document.data.summary.whtTotal,
      whtAmount: isUseCurrency
        ? documentModel.document.data.currency.whtTotal
        : documentModel.document.data.summary.whtTotal,
    };
  }

  return summarizeInfo;
}

export function GetPaymentGroupsAfterSort(paymentGroups: Array<PaymentGroupModel>) {
  const paymentGroupsMock: Array<PaymentGroupModel> = [];
  if (paymentGroups && paymentGroups.length > 0) {
    for (const paymentGroup of paymentGroups) {
      const paymentCheque: Array<PaymentModel> = [];
      const paymentsCash: Array<PaymentModel> = [];
      const paymentsBank: Array<PaymentModel> = [];
      const paymentsEwallet: Array<PaymentModel> = [];
      const paymentsExpenseClaim: Array<PaymentModel> = [];
      const paymentsTransaction: Array<PaymentModel> = [];
      const paymentsAccount: Array<PaymentModel> = [];
      let newPayments: Array<PaymentModel> = [];
      for (const payment of paymentGroup.payments) {
        if (payment.paymentCheque.chequeId > 0) {
          paymentCheque.push(payment);
        } else if (payment.paymentMethod.paymentMethodType == BankAccountType.Cash) {
          paymentsCash.push(payment);
        } else if (payment.paymentMethod.paymentMethodType == BankAccountType.Bank) {
          paymentsBank.push(payment);
        } else if (payment.paymentMethod.paymentMethodType == BankAccountType.EWallet) {
          paymentsEwallet.push(payment);
        } else if (payment.paymentMethod.paymentMethodType == BankAccountType.ExpenseClaim) {
          paymentsExpenseClaim.push(payment);
        } else if (payment.paymentTransaction.transactionId > 0) {
          paymentsTransaction.push(payment);
        } else if (payment.paymentAccount.accountId > 0) {
          paymentsAccount.push(payment);
        }
      }
      paymentsBank.sort((a, b) => a.paymentMethod.bankReferenceType - b.paymentMethod.bankReferenceType);
      newPayments = newPayments.concat(paymentCheque);
      newPayments = newPayments.concat(paymentsCash);
      newPayments = newPayments.concat(paymentsBank);
      newPayments = newPayments.concat(paymentsEwallet);
      newPayments = newPayments.concat(paymentsExpenseClaim);
      newPayments = newPayments.concat(paymentsTransaction);
      newPayments = newPayments.concat(paymentsAccount);
      let paymentGroupMock: PaymentGroupModel = NewObject(paymentGroup);
      paymentGroupMock.payments = newPayments;
      paymentGroupsMock.push(paymentGroupMock);
    }
  }
  return paymentGroupsMock;
}

export function GetMerchantPayment(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): ElementMerchantPaymentModel {
  const merchantPayment: ElementMerchantPaymentModel = {
    paymentElementType: CheckPayment(documentModel, settingDocumentTemplateDefault),
    defaultPaymentMethodChannel: documentModel.document.defaultPaymentMethodChannel,
    paymentGroups: GetPaymentGroupsAfterSort(documentModel.document.data.paymentGroups),
    settingPaymentGroupList: {
      isShowPaymentGroupList:
        documentModel.template.merchantPayment.settingPaymentGroupList == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentGroupList.isShowPaymentGroupList,
      isShowPaymentGroupAll:
        documentModel.template.merchantPayment.settingPaymentGroupList == undefined
          ? false
          : documentModel.template.merchantPayment.settingPaymentGroupList.isShowPaymentGroupAll ?? false,
      isShowBankAccountBranchName:
        documentModel.template.merchantPayment.settingPaymentGroupList == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentGroupList.isShowBankAccountBranchName ?? true,
      isShowBankAccountName:
        documentModel.template.merchantPayment.settingPaymentGroupList == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentGroupList.isShowBankAccountName ?? true,
      isShowBankAccountNumber:
        documentModel.template.merchantPayment.settingPaymentGroupList == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentGroupList.isShowBankAccountNumber ?? true,
      isShowWhtRefNumber:
        documentModel.template.merchantPayment.settingPaymentGroupList == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentGroupList.isShowWhtRefNumber ??
            GetDefaultIsShowWHTRefNumber(documentModel.transactionType, documentModel.financeType),
    },
    settingPaymentMethodChannel: {
      isShowBankAccountBranchCode:
        documentModel.template.merchantPayment.settingPaymentMethodChannel == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentMethodChannel.isShowBankAccountBranchCode,
      isShowBankAccountBranchName:
        documentModel.template.merchantPayment.settingPaymentMethodChannel == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentMethodChannel.isShowBankAccountBranchName,
      isShowBankAccountName:
        documentModel.template.merchantPayment.settingPaymentMethodChannel == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentMethodChannel.isShowBankAccountName,
      isShowBankAccountNumber:
        documentModel.template.merchantPayment.settingPaymentMethodChannel == undefined
          ? true
          : documentModel.template.merchantPayment.settingPaymentMethodChannel.isShowBankAccountNumber ?? true,
    },
  };
  if (settingDocumentTemplateDefault) {
    merchantPayment.settingPaymentGroupList = {
      isShowPaymentGroupList:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentGroupList.isShowPaymentGroupList,
      isShowPaymentGroupAll:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentGroupList.isShowPaymentGroupAll,
      isShowBankAccountBranchName:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentGroupList.isShowBankAccountBranchName,
      isShowBankAccountName:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentGroupList.isShowBankAccountName,
      isShowBankAccountNumber:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentGroupList.isShowBankAccountNumber,
      isShowWhtRefNumber: settingDocumentTemplateDefault.merchantPayment.settingPaymentGroupList.isShowWhtRefNumber,
    };
    merchantPayment.settingPaymentMethodChannel = {
      isShowBankAccountBranchCode:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentMethodChannel.isShowBankAccountBranchCode,
      isShowBankAccountBranchName:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentMethodChannel.isShowBankAccountBranchName,
      isShowBankAccountName:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentMethodChannel.isShowBankAccountName,
      isShowBankAccountNumber:
        settingDocumentTemplateDefault.merchantPayment.settingPaymentMethodChannel.isShowBankAccountNumber,
    };
  }
  return merchantPayment;
}

export function GetPrefixName(ordinaryPerson: OrdinaryPersonModel, merchantType: MerchantType) {
  let prefix = "";
  if (merchantType === MerchantType.OrdinaryPerson) {
    switch (ordinaryPerson.namePrefixType) {
      case OrdinaryPersonPrefixType.Sir:
        prefix = i18n.t("PrefixName.Khun").toString() + " ";
        break;
      case OrdinaryPersonPrefixType.Mr:
        prefix = i18n.t("PrefixName.Mr").toString() + " ";
        break;
      case OrdinaryPersonPrefixType.Mrs:
        prefix = i18n.t("PrefixName.Mrs").toString() + " ";
        break;
      case OrdinaryPersonPrefixType.Ms:
        prefix = i18n.t("PrefixName.Ms").toString() + " ";
        break;
      case OrdinaryPersonPrefixType.Other:
        prefix = ordinaryPerson.namePrefixOther + " ";
        break;
    }
  }
  return prefix;
}

export function CheckPayment(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
) {
  switch (documentModel.transactionType) {
    case TransactionType.Invoice:
      if (documentModel.financeType === FinanceType.OutFlow) {
        if (documentModel.headerOptionType === ExpenseHeaderType.PaymentNoteHeader) {
          if (documentModel.document.data.paymentGroups.length > 0) {
            return PaymentElementType.Payment;
          } else {
            return PaymentElementType.List;
          }
        } else {
          if (documentModel.document.data.paymentGroups.length > 0) {
            return PaymentElementType.Payment;
          }
          return PaymentElementType.None;
        }
      }

      break;
    case TransactionType.Receipt:
      if (documentModel.document.data.paymentGroups.length > 0) {
        return PaymentElementType.Payment;
      }
      return PaymentElementType.None;
      break;
    case TransactionType.CreditNote:
      if (documentModel.financeType === FinanceType.OutFlow) {
        if (documentModel.document.data.paymentGroups.length > 0) {
          return PaymentElementType.Payment;
        }
        return PaymentElementType.None;
      } else if (documentModel.financeType === FinanceType.InFlow) {
        if (documentModel.document.data.paymentGroups.length > 0) {
          return PaymentElementType.Payment;
        }
        return PaymentElementType.List;
      }
      break;
    case TransactionType.DebitNote:
      if (documentModel.financeType === FinanceType.OutFlow) {
        if (documentModel.document.data.paymentGroups.length > 0) {
          return PaymentElementType.Payment;
        }
        return PaymentElementType.None;
      } else if (documentModel.financeType === FinanceType.InFlow) {
        if (documentModel.document.data.paymentGroups.length > 0) {
          return PaymentElementType.Payment;
        }
        return PaymentElementType.List;
      }
      break;
    case TransactionType.Deposit:
      if (documentModel.financeType === FinanceType.InFlow) {
        if (documentModel.document.data.paymentGroups.length > 0) {
          return PaymentElementType.Payment;
        }
        return PaymentElementType.List;
      } else if (documentModel.financeType === FinanceType.OutFlow) {
        if (documentModel.headerOptionType === DepositExpenseHeaderType.PaymentNoteHeader) {
          if (documentModel.document.data.paymentGroups.length > 0) {
            return PaymentElementType.Payment;
          } else {
            return PaymentElementType.List;
          }
        } else {
          return PaymentElementType.Payment;
        }
      }
  }
  return settingDocumentTemplateDefault
    ? settingDocumentTemplateDefault.merchantPayment.paymentElementType
    : documentModel.template.merchantPayment.paymentElementType;
}

export function GetHeaderDocument(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): HeaderDocumentModel {
  let defaultTemplate: SettingDocumentTemplateModel = GetDefaultSettingTemplateModel(
    documentModel.transactionType,
    documentModel.financeType,
    documentModel.expenseType,
    documentModel.headerOptionType,
    documentModel.document.data.isTaxInvoice,
    documentModel.document.data.currency.toCurrency.currencyCode
  );

  const headerDocument: HeaderDocumentModel = {
    colorCode: documentModel.template.colorCode,
    isShowColorBackground: documentModel.template.isShowColorBackground ?? defaultTemplate.isShowColorBackground,
    isShowColorBorder: documentModel.template.isShowColorBorder ?? defaultTemplate.isShowColorBorder,
    isShowColorBackgroundCopy:
      documentModel.template.isShowColorBackgroundCopy ?? defaultTemplate.isShowColorBackgroundCopy,
    isShowColorBorderCopy: documentModel.template.isShowColorBorderCopy ?? defaultTemplate.isShowColorBorderCopy,
    colorCodeCopy: documentModel.template.colorCodeCopy ?? documentModel.template.colorCode,
    documentFontType: documentModel.template.documentFontType ?? DocumentFontType.Sukhumvit,
    documentFormat: documentModel.template.documentFormat ?? DocumentFormat.FormatOne,
    language: documentModel.template.language ?? LanguageType.Th,
    areaPunchingType: documentModel.template.areaPunchingType ?? SettingAreaPunchingType.None,
    dateOptionType: documentModel.template.dateOptionType ?? DateOptionType.DateADType1,
    merchantLogo: GetMerchantLogo(documentModel, settingDocumentTemplateDefault),
    isHaveEtaxInvoice: SetOptionType(documentModel.document.data.isSendETaxInvoice, OptionType.ETaxInvoice),
    isShowEtaxInvoice: documentModel.template.isShowEtaxInvoice,
    headType: GetHeadType(documentModel, settingDocumentTemplateDefault),
    documentName: GetDocumentName(documentModel, settingDocumentTemplateDefault),
    merchant: GetMerchant(documentModel, settingDocumentTemplateDefault),
    contact: GetContact(documentModel, settingDocumentTemplateDefault),
    documentInfo: GetDocumentInfo(documentModel, settingDocumentTemplateDefault),
    merchantPerson: GetMerchantPerson(documentModel, settingDocumentTemplateDefault),
    classifications: GetClassificationsList(documentModel),
  };

  if (settingDocumentTemplateDefault) {
    headerDocument.colorCode = settingDocumentTemplateDefault.colorCode;
    headerDocument.colorCodeCopy = settingDocumentTemplateDefault.colorCodeCopy;
    headerDocument.isShowColorBackground = settingDocumentTemplateDefault.isShowColorBackground;
    headerDocument.isShowColorBorder = settingDocumentTemplateDefault.isShowColorBorder;
    headerDocument.isShowColorBackgroundCopy = settingDocumentTemplateDefault.isShowColorBackgroundCopy;
    headerDocument.isShowColorBorderCopy = settingDocumentTemplateDefault.isShowColorBorderCopy;
    headerDocument.language = settingDocumentTemplateDefault.language;
    headerDocument.areaPunchingType = settingDocumentTemplateDefault.areaPunchingType;
    headerDocument.isShowEtaxInvoice = settingDocumentTemplateDefault.isShowEtaxInvoice;
    headerDocument.documentFormat = settingDocumentTemplateDefault.documentFormat;
  }

  SetLanguage(headerDocument.language);
  return headerDocument;
}

export function SetOptionType(isOption: boolean, optionType: OptionType) {
  const optionName = SetOptionNameType(optionType);
  const urlOption: any = router.currentRoute.query.option;
  if (urlOption) {
    const optionObject = StringToObject(urlOption.PeakDecryptionToString());
    if (optionObject[optionName] === true) {
      return true;
    } else if (optionObject[optionName] === false) {
      return false;
    }
  }
  return isOption;
}

export function SetOptionNameType(optionType: OptionType) {
  let optionName: any = "";

  switch (optionType) {
    case OptionType.ETaxInvoice:
      optionName = "eTaxInvoice";
      break;
    case OptionType.IsDeleted:
      optionName = "isDeleted";
      break;
  }

  return optionName;
}

export function SetLanguage(languageType: LanguageType) {
  if (languageType === LanguageType.Th) {
    i18n.locale = "th";
  } else {
    i18n.locale = "en";
  }
}

export function GetBodyDocument(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): DetailDocumentModel {
  const detail: DetailDocumentModel = {
    itemsDocumentType: GetItemsDocumentType(documentModel),
    settigColumn: GetSettingColumn(documentModel, settingDocumentTemplateDefault),
    settigDescription: GetSettingDescription(documentModel, settingDocumentTemplateDefault),
    productList: GetProductList(documentModel),
    billingList: GetBillingList(documentModel),
    assetGroups: GetAssetGroupList(documentModel),
    assets: GetAssetList(documentModel),
    isShowWatermarkPaid: documentModel.template.isShowWatermarkPaid,
  };

  if (settingDocumentTemplateDefault) {
    detail.isShowWatermarkPaid = settingDocumentTemplateDefault.isShowWatermarkPaid;
  }
  return detail;
}

export function GetItemsDocumentType(documentModel: OnlineViewModel) {
  if (documentModel.document.data.items.length > 0) {
    return ItemsDocumentType.ItemProduct;
  } else if (documentModel.document.data.billing.length > 0) {
    return ItemsDocumentType.ItemBilling;
  } else if (documentModel.document.data.assets.length > 0) {
    return ItemsDocumentType.ItemAssets;
  } else if (documentModel.document.data.assetGroups.length > 0) {
    return ItemsDocumentType.ItemAssetGroup;
  } else {
    return ItemsDocumentType.None;
  }
}

export function GetFooterDocment(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): FooterDocumentModel {
  const footer: FooterDocumentModel = {
    currencyCode: GetCurrencyCode(documentModel.template.settingCurrency),
    amountInfo: GetAmountInfo(documentModel, settingDocumentTemplateDefault),
    summarizeInfo: GetSummarizeInfo(documentModel, settingDocumentTemplateDefault),
    payment: GetMerchantPayment(documentModel, settingDocumentTemplateDefault),
    remark: {
      value: documentModel.document.data.remark,
      isShowElement: documentModel.template.remark.isShowElement,
    },
    reason: {
      value: documentModel.document.data.reason.reasonDescription,
      isShowElement: documentModel.template.reason ? documentModel.template.reason.isShowElement : false,
    },
    expenseClaimDetail: GetExpenseClaimDetail(documentModel, settingDocumentTemplateDefault),
    certified: GetCertified(documentModel, settingDocumentTemplateDefault),
    documentControlNo: GetDocumentControlNo(documentModel),
  };

  if (settingDocumentTemplateDefault) {
    footer.remark.isShowElement = settingDocumentTemplateDefault.remark.isShowElement;
    footer.reason.isShowElement = settingDocumentTemplateDefault.reason.isShowElement;
  }
  return footer;
}

export function GetCurrencyDetail(documentModel: OnlineViewModel) {
  const isBillingNote =
    documentModel.transactionType === TransactionType.BillingNote ||
    documentModel.document.data.reference.document.transactionType === TransactionType.BillingNote;
  const currencyDetail: CurrencyDetailModel = {
    exchangeRates: isBillingNote
      ? documentModel.document.data.billing[0].document.exchangeRates
      : documentModel.document.data.currency.exchangeRates,
    exchangeRatioType: isBillingNote
      ? documentModel.document.data.billing[0].document.exchangeRatioType
      : documentModel.document.data.currency.exchangeRatioType,
    fromCurrency: documentModel.document.data.currency.fromCurrency,
    toCurrency: documentModel.document.data.currency.toCurrency,
    settingCurrency: documentModel.template.settingCurrency,
  };
  return currencyDetail;
}

export function SetCurrencyDefault(documentModel: OnlineViewModel) {
  if (
    (documentModel.document.data.currency.fromCurrency.currencyCode === CurrencyCode.THB &&
      documentModel.document.data.currency.toCurrency.currencyCode === CurrencyCode.THB) ||
    (documentModel.template.settingCurrency !== CurrencyCode.THB &&
      documentModel.template.settingCurrency !== documentModel.document.data.currency.toCurrency.currencyCode) ||
    documentModel.template.settingCurrency === undefined ||
    documentModel.transactionType === TransactionType.Quotation
  ) {
    return documentModel.document.data.currency.toCurrency.currencyCode;
  }
  return documentModel.template.settingCurrency;
}

export function SetIsCanSettingCurrency(documentTemplate: DocumentTemplateModel) {
  if (
    (documentTemplate.currency.toCurrency.currencyCode === CurrencyCode.THB &&
      documentTemplate.currency.fromCurrency.currencyCode === CurrencyCode.THB) ||
    (documentTemplate.currency.exchangeRates === 1 &&
      documentTemplate.currency.exchangeRatioType === CurrencyRatio.Normal)
  ) {
    return false;
  }
  return true;
}

export function GetDocumentTemplate(
  documentModel: OnlineViewModel,
  settingDocumentTemplateDefault?: SettingDocumentTemplateModel
): DocumentTemplateModel {
  documentModel.template.settingCurrency = SetCurrencyDefault(documentModel);
  const documentTemplate = new DocumentTemplateModel();
  documentTemplate.transactionType = documentModel.transactionType;
  documentTemplate.financeType = documentModel.financeType;
  documentTemplate.expenseType = documentModel.expenseType;
  documentTemplate.headerOptionType = documentModel.headerOptionType;
  documentTemplate.header = GetHeaderDocument(documentModel, settingDocumentTemplateDefault);
  documentTemplate.detail = GetBodyDocument(documentModel, settingDocumentTemplateDefault);
  documentTemplate.footer = GetFooterDocment(documentModel, settingDocumentTemplateDefault);
  documentTemplate.isDeleted = SetOptionType(documentModel.document.data.isDeleted, OptionType.IsDeleted);
  documentTemplate.isRejected = documentModel.document.data.isRejected;
  documentTemplate.statusType = documentModel.document.data.statusType;
  documentTemplate.currency = GetCurrencyDetail(documentModel);

  return documentTemplate;
}
export function GetHeaderBillingColumn(documentTemplate: DocumentTemplateModel): HeaderBillingColumnModel {
  let documentNumberWidth = 715; //maxWidth 753px
  let input = GetInputForSetBillingColumn(documentTemplate);
  let headerBillingColumn: HeaderBillingColumnModel = {
    documentNumber: {
      isShowColumn: true,
      width: 0,
      align: "left",
    },
    taxInvoiceNumber: {
      isShowColumn: true,
      width: 0,
      align: "center",
    },
    billedAmount: {
      isShowColumn: true,
      width: GetBillingWidthColumnForBilledAmount(input.billedAmount.ToPeakTransactionItemFormat()),
      align: "right",
    },
    dueDateTime: {
      isShowColumn: true,
      width: 100,
      align: "center",
    },
    issuedDateTime: {
      isShowColumn: true,
      width: 100,
      align: "center",
    },
    preVatAmount: {
      isShowColumn: true,
      width: GetBillingWidthColumnForBilledAmount(input.preVatAmount.ToPeakTransactionItemFormat()),
      align: "right",
    },
    whtAmount: {
      isShowColumn: true,
      width: GetBillingWidthColumnForWhtAmount(input.wht.ToPeakTransactionItemFormat()),
      align: "right",
    },
  };

  for (const [key, value] of Object.entries(headerBillingColumn)) {
    documentNumberWidth -= value.width;
  }

  headerBillingColumn.documentNumber.width = documentNumberWidth;

  return headerBillingColumn;
}

export function GetHeaderBillingProductItemColumn(
  documentTemplate: DocumentTemplateModel
): HeaderBillingProductItemColumnModel {
  let documentNumberWidth = 697;
  const isShowProductItems = documentTemplate.detail.settigColumn.isShowProductItems;
  let input = GetInputForSetBillingItemColumn(documentTemplate);
  let headerBillingProductItemColumn: HeaderBillingProductItemColumnModel = {
    description: {
      isShowColumn: isShowProductItems,
      width: 0,
      align: "left",
    },
    amount: {
      isShowColumn: isShowProductItems,
      width: GetWidthColumnFromLangthNumberForBillingNoteItems(input.quantity.ToPeakTransactionItemFormat()),
      align: "right",
    },
    pricePerItem: {
      isShowColumn: isShowProductItems,
      width: GetWidthColumnFromLangthNumberForBillingNoteItems(input.pricePerItem.ToPeakTransactionItemFormat()),
      align: "right",
    },
    vatPercent: {
      isShowColumn: isShowProductItems,
      width: 60,
      align: "right",
    },
    preVatAmount: {
      isShowColumn: isShowProductItems,
      width: GetWidthColumnForPreVatAmount(input.preVatAmount.ToPeakTransactionItemFormat()),
      align: "right",
    },
    whtAmount: {
      isShowColumn: isShowProductItems,
      width: GetBillingWidthColumnForWhtAmount(input.wht.ToPeakTransactionItemFormat()),
      align: "right",
    },
  };

  for (const [key, value] of Object.entries(headerBillingProductItemColumn)) {
    documentNumberWidth -= value.width;
  }

  headerBillingProductItemColumn.description.width = documentNumberWidth;

  return headerBillingProductItemColumn;
}

function GetInputForSetColumn(documentTemplate: DocumentTemplateModel) {
  let quantity = 0;
  let price = 0;
  let discount = "";
  let preVatAmount = 0;
  let incVatAmount = 0;
  if (documentTemplate.detail.productList && documentTemplate.detail.productList.length > 0) {
    for (const productItem of documentTemplate.detail.productList) {
      if (quantity <= productItem.quantity.ToNumber()) {
        quantity = productItem.quantity.ToNumber();
      }
      if (price <= productItem.price.ToNumber()) {
        price = productItem.price.ToNumber();
      }
      if (discount.length <= productItem.discount.length) {
        discount = productItem.discount;
      }
      if (preVatAmount <= productItem.preVatAmount.ToNumber()) {
        preVatAmount = productItem.preVatAmount.ToNumber();
      }
      if (incVatAmount <= productItem.incVatAmount.ToNumber()) {
        incVatAmount = productItem.incVatAmount.ToNumber();
      }
    }
  }

  if (documentTemplate.detail.assetGroups && documentTemplate.detail.assetGroups.length > 0) {
    for (const assetGroup of documentTemplate.detail.assetGroups) {
      if (quantity <= assetGroup.quantity.ToNumber()) {
        quantity = assetGroup.quantity.ToNumber();
      }
      if (price <= assetGroup.price.ToNumber()) {
        price = assetGroup.price.ToNumber();
      }
      if (discount.length <= assetGroup.discount.length) {
        discount = assetGroup.discount;
      }
      if (preVatAmount <= assetGroup.preVatAmount.ToNumber()) {
        preVatAmount = assetGroup.preVatAmount.ToNumber();
      }
      if (incVatAmount <= assetGroup.incVatAmount.ToNumber()) {
        incVatAmount = assetGroup.incVatAmount.ToNumber();
      }
    }
  }

  if (documentTemplate.detail.assets && documentTemplate.detail.assets.length > 0) {
    for (const asset of documentTemplate.detail.assets) {
      if (quantity <= asset.quantity.ToNumber()) {
        quantity = asset.quantity.ToNumber();
      }
      if (price <= asset.price.ToNumber()) {
        price = asset.price.ToNumber();
      }
      if (discount.length <= asset.discount.length) {
        discount = asset.discount;
      }
      if (preVatAmount <= asset.preVatAmount.ToNumber()) {
        preVatAmount = asset.preVatAmount.ToNumber();
      }
      if (incVatAmount <= asset.incVatAmount.ToNumber()) {
        incVatAmount = asset.incVatAmount.ToNumber();
      }
    }
  }

  return { quantity, price, discount, preVatAmount, incVatAmount };
}

function GetInputForSetBillingColumn(documentTemplate: DocumentTemplateModel) {
  let wht = 0;
  let preVatAmount = 0;
  let billedAmount = 0;
  if (documentTemplate.detail.billingList && documentTemplate.detail.billingList.length > 0) {
    for (const billing of documentTemplate.detail.billingList) {
      if (wht <= billing.wht.ToNumber()) {
        wht = billing.wht.ToNumber();
      }
      if (preVatAmount <= billing.document.transactionNetAmount.ToNumber()) {
        preVatAmount = billing.document.transactionNetAmount.ToNumber();
      }
      if (billedAmount <= billing.billedCurrencyAmount.ToNumber()) {
        billedAmount = billing.billedCurrencyAmount.ToNumber();
      }
    }
  }

  return { wht, preVatAmount, billedAmount };
}

function GetInputForSetBillingItemColumn(documentTemplate: DocumentTemplateModel) {
  let wht = 0;
  let preVatAmount = 0;
  let pricePerItem = 0;
  let quantity = 0;
  if (documentTemplate.detail.billingList && documentTemplate.detail.billingList.length > 0) {
    for (const billing of documentTemplate.detail.billingList) {
      for (const billingItem of billing.productItems) {
        if (wht <= billingItem.whtAmount.ToNumber()) {
          wht = billingItem.whtAmount.ToNumber();
        }
        if (preVatAmount <= billingItem.preVatAmount.ToNumber()) {
          preVatAmount = billingItem.preVatAmount.ToNumber();
        }
        if (pricePerItem <= billingItem.pricePerItem.ToNumber()) {
          pricePerItem = billingItem.pricePerItem.ToNumber();
        }
        if (quantity <= billingItem.quantity.ToNumber()) {
          quantity = billingItem.quantity.ToNumber();
        }
      }
    }
  }

  return { wht, preVatAmount, pricePerItem, quantity };
}

function GetWidthColumnFromLangthNumber(numberStr: string) {
  let widthColumn = 55;
  numberStr = numberStr.replace(",", "");
  numberStr = numberStr.replace(".", "");

  if (numberStr.length > 8) {
    widthColumn = 100;
  } else if (numberStr.length > 5) {
    widthColumn = 70;
  }

  return widthColumn;
}

function GetWidthColumnFromLangthNumberForBillingNoteItems(numberStr: string) {
  let widthColumn = 95;
  numberStr = numberStr.replace(",", "");
  numberStr = numberStr.replace(".", "");

  if (numberStr.length > 12) {
    widthColumn = 120;
  } else if (numberStr.length > 8) {
    widthColumn = 105;
  }

  return widthColumn;
}

function GetWHTWidthColumnFromLangthNumberForBillingNoteItems(numberStr: string) {
  let widthColumn = 55;
  numberStr = numberStr.replace(",", "");
  numberStr = numberStr.replace(".", "");

  if (numberStr.length > 8) {
    widthColumn = 120;
  }

  return widthColumn;
}

function GetWidthColumnForPreVatAmount(numberStr: string) {
  let widthColumn = 85;
  numberStr = numberStr.replace(",", "");
  numberStr = numberStr.replace(".", "");

  if (numberStr.length > 8) {
    widthColumn = 100;
  }

  return widthColumn;
}

function GetBillingWidthColumnForWhtAmount(numberStr: string) {
  let widthColumn = 50;
  numberStr = numberStr.replace(",", "");
  numberStr = numberStr.replace(".", "");
  if (numberStr.length > 15) {
    widthColumn = 120;
  } else if (numberStr.length > 10) {
    widthColumn = 100;
  }

  return widthColumn;
}

function GetBillingWidthColumnForBilledAmount(numberStr: string) {
  let widthColumn = 100;
  numberStr = numberStr.replace(",", "");
  numberStr = numberStr.replace(".", "");
  if (numberStr.length > 15) {
    widthColumn = 130;
  } else if (numberStr.length > 12) {
    widthColumn = 120;
  }

  return widthColumn;
}

export function GetHeaderItemColumn(documentTemplate: DocumentTemplateModel): HeaderItemColumnModel {
  let descriptionWidth = 715; //maxWidth 753px
  let input = GetInputForSetColumn(documentTemplate);
  let headerItemColumn: HeaderItemColumnModel = {
    productImage: {
      isShowColumn: false,
      width: 40,
      align: "left",
    },
    description: {
      isShowColumn: true,
      width: 0,
      align: "left",
    },
    quantity: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowAmount,
      width: GetWidthColumnFromLangthNumber(input.quantity.ToPeakTransactionItemFormat()),
      align: "right",
    },
    unit: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowUnit,
      width: 70,
      align: "center",
    },
    price: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowPrice,
      width: GetWidthColumnFromLangthNumber(input.price.ToPeakTransactionItemFormat()),
      align: "right",
    },
    discount: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowDiscount,
      width: GetWidthColumnFromLangthNumber(input.discount),
      align: "right",
    },
    vat: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowVatAmount,
      width: 40,
      align: "right",
    },
    preVatAmount: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowPreVatAmount,
      width: GetWidthColumnForPreVatAmount(input.preVatAmount.ToPeakTransactionItemFormat()),
      align: "right",
    },
    incVatAmount: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowIncVatAmount,
      width: GetWidthColumnForPreVatAmount(input.incVatAmount.ToPeakTransactionItemFormat()),
      align: "right",
    },
    whtAmount: {
      isShowColumn: documentTemplate.detail.settigColumn.isShowWhtAmount,
      width: 80,
      align: "right",
    },
  };

  for (const [key, value] of Object.entries(headerItemColumn)) {
    if (value.isShowColumn) {
      descriptionWidth -= value.width;
    }
  }

  headerItemColumn.description.width = descriptionWidth;

  return headerItemColumn;
}

export function GetDocumentNameHeader(
  documentModel:
    | OnlineViewModel
    | JournalOnlineViewModel
    | WitholdingTaxOnlineViewModel
    | PP30OnlineViewModel
    | ContactEnvelopeOnlineViewModel
    | ExecutiveSummaryOnlineViewModel
    | OnlineViewCustomizeModel
) {
  let documentName: string = "";
  if (documentModel instanceof JournalOnlineViewModel) {
    switch (documentModel.transactionType) {
      case TransactionType.DailyJournal: {
        documentName = i18n
          .t("Head_DailyJournal", { journalType: GetJournalTypeName(documentModel.document.data.journalType) })
          .toString();
      }
    }
  } else if (documentModel instanceof WitholdingTaxOnlineViewModel) {
    switch (documentModel.transactionType) {
      case TransactionType.WithholdingTax: {
        documentName = i18n.t("Withholding_Tax_Certificate").toString();
      }
    }
  } else if (documentModel instanceof PP30OnlineViewModel) {
    switch (documentModel.transactionType) {
      case TransactionType.PP30: {
        documentName = i18n.t("PP30").toString();
      }
    }
  } else if (documentModel instanceof PndOnlineViewModel) {
    switch (documentModel.transactionType) {
      case TransactionType.Pnd1: {
        documentName = i18n.t("PND1").toString();
        break;
      }
      case TransactionType.Pnd2: {
        documentName = i18n.t("PND2").toString();
        break;
      }
      case TransactionType.Pnd3: {
        documentName = i18n.t("PND3").toString();
        break;
      }
      case TransactionType.Pnd53: {
        documentName = i18n.t("PND53").toString();
        break;
      }
    }
  } else if (documentModel instanceof ContactEnvelopeOnlineViewModel) {
    documentName = i18n.t("Envelope_Document").toString();
  } else if (documentModel instanceof ExecutiveSummaryOnlineViewModel) {
    documentName = i18n.t("Executive_Summary").toString();
  } else if (documentModel instanceof OnlineViewModel || documentModel instanceof OnlineViewCustomizeModel) {
    documentName = GetDocumentNameForTransaction(
      documentModel.transactionType,
      documentModel.financeType,
      documentModel.expenseType,
      documentModel.document.data.isTaxInvoice
    );
  }

  return documentName;
}

export function GetDocumentNameForTransaction(
  transactionType: TransactionType,
  financeType: FinanceType,
  expenseType: ExpenseType,
  isTaxInvoice: boolean = false
) {
  let documentName: string = "";

  switch (transactionType) {
    case TransactionType.Quotation: {
      if (financeType === FinanceType.InFlow) {
        documentName = i18n.t("Quotation").toString();
      } else if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("PurchaseOrder").toString();
      }
      break;
    }
    case TransactionType.Invoice:
      if (financeType === FinanceType.InFlow) {
        documentName = i18n.t("Invoice").toString();
        if (isTaxInvoice) {
          documentName += "/" + i18n.t("TaxInvoice").toString();
        }
      } else if (financeType === FinanceType.OutFlow) {
        if (expenseType === ExpenseType.Expense) {
          documentName = i18n.t("Expense").toString();
        } else if (expenseType === ExpenseType.PurchaseInventory) {
          documentName = i18n.t("PurchaseInventory").toString();
        } else if (expenseType === ExpenseType.PurchaseAsset) {
          documentName = i18n.t("Purchase_Asset").toString();
        }
      }
      break;
    case TransactionType.Receipt:
      documentName = i18n.t("Receipt").toString();
      if (isTaxInvoice) {
        documentName += "/" + i18n.t("TaxInvoice").toString();
      }
      break;
    case TransactionType.Deposit:
      if (financeType === FinanceType.InFlow) {
        documentName = i18n.t("Deposit").toString();
      } else if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("Received_Deposit").toString();
      }
      break;
    case TransactionType.GoodsReceipt:
      if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("Goods_Receipt").toString();
      }
      break;
    case TransactionType.InvoiceReceipt:
      if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("Invoice_Receipt").toString();
      }
      break;
    case TransactionType.TaxInvoice:
      documentName = i18n.t("TaxInvoice").toString();
      break;
    case TransactionType.CreditNote: {
      if (financeType === FinanceType.InFlow) {
        documentName = i18n.t("Credit_Note").toString();
      } else if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("ReceiveCreditNote").toString();
      }
      break;
    }
    case TransactionType.DebitNote: {
      if (financeType === FinanceType.InFlow) {
        documentName = i18n.t("Debit_Note").toString();
      } else if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("ReceiveDebitNote").toString();
      }
      break;
    }
    case TransactionType.BillingNote: {
      if (financeType === FinanceType.InFlow) {
        documentName = i18n.t("Billing_Note").toString();
      } else if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("Combine_Payment_Note").toString();
      }
      break;
    }
    case TransactionType.PurchaseRequisition: {
      if (financeType === FinanceType.OutFlow) {
        documentName = i18n.t("PurchaseRequisition").toString();
      }
      break;
    }
  }

  return documentName;
}

export function GetDefaultSettingTemplateModel(
  transactionType: number,
  financeType: FinanceType,
  expenseType: ExpenseType,
  headerOptionType: number,
  isTaxInvoice: boolean,
  toCurrency: CurrencyCode = CurrencyCode.THB
) {
  let settingTemplate: any = null;

  switch (transactionType) {
    case TransactionType.Quotation: {
      if (financeType === FinanceType.InFlow) {
        settingTemplate = GetQuotationSettingDocument(headerOptionType ?? 0, toCurrency);
      } else if (financeType === FinanceType.OutFlow) {
        settingTemplate = GetPurchaseOrderSettingDocument(headerOptionType ?? 0, toCurrency);
      }
      break;
    }
    case TransactionType.Invoice: {
      if (financeType === FinanceType.InFlow) {
        settingTemplate = GetInvoiceSettingDocument(headerOptionType ?? 0, toCurrency);
      } else if (financeType === FinanceType.OutFlow) {
        settingTemplate = GetExpenseSettingDocument(expenseType ?? ExpenseType.None, headerOptionType ?? 0, toCurrency);
      }
      break;
    }
    case TransactionType.Deposit: {
      if (financeType === FinanceType.InFlow) {
        settingTemplate = GetDepositSettingDocument(headerOptionType ?? 0, toCurrency);
      } else if (financeType === FinanceType.OutFlow) {
        settingTemplate = GetDepositExpenseSettingDocument(headerOptionType ?? 0, toCurrency);
      }
      break;
    }
    case TransactionType.GoodsReceipt: {
      settingTemplate = GetGoodsReceiptSettingDocument(
        expenseType ?? ExpenseType.None,
        headerOptionType ?? 0,
        toCurrency
      );
      break;
    }
    case TransactionType.InvoiceReceipt: {
      settingTemplate = GetInvoiceReceiptSettingDocument(headerOptionType ?? 0, toCurrency);
      break;
    }
    case TransactionType.Receipt: {
      settingTemplate = GetReceiptSettingDocument(isTaxInvoice, headerOptionType ?? 0, toCurrency);
      break;
    }
    case TransactionType.CreditNote: {
      if (financeType === FinanceType.InFlow) {
        settingTemplate = GetCreditNoteSettingDocument(headerOptionType ?? 0, toCurrency);
      } else if (financeType === FinanceType.OutFlow) {
        settingTemplate = GetCreditNoteExpenseSettingDocument(headerOptionType ?? 0, toCurrency);
      }
      break;
    }
    case TransactionType.DebitNote: {
      if (financeType === FinanceType.InFlow) {
        settingTemplate = GetDebitNoteSettingDocument(headerOptionType ?? 0, toCurrency);
      } else if (financeType === FinanceType.OutFlow) {
        settingTemplate = GetDebitNoteExpenseSettingDocument(headerOptionType ?? 0, toCurrency);
      }
      break;
    }
    case TransactionType.BillingNote: {
      if (financeType === FinanceType.InFlow) {
        settingTemplate = GetBillingNoteSettingDocument(toCurrency);
      } else if (financeType === FinanceType.OutFlow) {
        settingTemplate = GetCombinePaymentNoteSettingDocument(headerOptionType ?? 0, toCurrency);
      }
      break;
    }
    case TransactionType.TaxInvoice: {
      settingTemplate = GetTaxInvoiceSettingDocument(headerOptionType ?? 0, toCurrency);
      break;
    }
    case TransactionType.DailyJournal: {
      settingTemplate = GetJournalSettingDocument(headerOptionType ?? 0);
      break;
    }
    case TransactionType.WithholdingTax: {
      settingTemplate = GetWitholdingTaxSettingDocument();
      break;
    }
    case TransactionType.Pnd1:
    case TransactionType.Pnd2:
    case TransactionType.Pnd3:
    case TransactionType.Pnd53: {
      settingTemplate = GetPndSettingDocument();
      break;
    }
    case TransactionType.PP30: {
      settingTemplate = GetPP30SettingDocument(financeType ?? FinanceType.None);
      break;
    }
    case TransactionType.PurchaseRequisition: {
      settingTemplate = GetPurchaseRequisitionSettingDocument(headerOptionType ?? 0, toCurrency);
      break;
    }
    case TransactionType.Envelope: {
      settingTemplate = GetContactEnvelopeSettingDocument();
      break;
    }
    case TransactionType.ExecutiveSummary: {
      settingTemplate = GetExecutiveSummarySettingDocument();
      break;
    }
  }

  return settingTemplate;
}

export function GetDefaultSettingTemplateByJournal() {
  let defaultTemplate: SettingJournalDocumentTemplateModel = new SettingJournalDocumentTemplateModel();
  defaultTemplate = GetJournalSettingDocument(JournalHeaderType.MainJournalHeader);
  return defaultTemplate;
}

export function ConvertToSettingDocumentTemplate(documentTemplate: DocumentTemplateModel, isTemplateMain: boolean) {
  let settingDocumentTemplate: SettingDocumentTemplateModel = {
    colorCode: documentTemplate.header.colorCode,
    isShowColorBackground: documentTemplate.header.isShowColorBackground,
    isShowColorBorder: documentTemplate.header.isShowColorBorder,
    isShowColorBackgroundCopy: documentTemplate.header.isShowColorBackgroundCopy,
    isShowColorBorderCopy: documentTemplate.header.isShowColorBorderCopy,
    colorCodeCopy: documentTemplate.header.colorCodeCopy,
    documentFontType: documentTemplate.header.documentFontType,
    documentFormat: documentTemplate.header.documentFormat,
    language: documentTemplate.header.language,
    areaPunchingType: documentTemplate.header.areaPunchingType ?? SettingAreaPunchingType.None,
    isShowWatermarkPaid: documentTemplate.detail.isShowWatermarkPaid ?? false,
    settingCurrency: documentTemplate.currency.settingCurrency,
    dateOptionType: documentTemplate.header.dateOptionType ?? DateOptionType.DateADType1,
    documentControlNo: {
      value: documentTemplate.footer.documentControlNo.value ?? "",
      alignment: documentTemplate.footer.documentControlNo.alignment ?? AlignmentDocumentControlNo.LeftFooter,
    },
    merchantLogo: {
      value: "",
      isShowElement: documentTemplate.header.merchantLogo.isShowElement,
    },
    isShowEtaxInvoice: documentTemplate.header.isShowEtaxInvoice,
    headType: {
      copyAmount: documentTemplate.header.headType.copyAmount,
      originalAmount: documentTemplate.header.headType.originalAmount,
      headerTitleType: documentTemplate.header.headType.headerOptionType,
      isShowDocumentSet: documentTemplate.header.headType.isShowDocumentSet,
      isShowHeaderOptionType: documentTemplate.header.headType.isShowHeaderOptionType,
    },
    documentName: {
      headerOptionType: documentTemplate.header.documentName.headerOptionName,
      documentHeaderSize: documentTemplate.header.documentName.documentHeaderSize ?? DocumentHeaderSize.Medium,
      isShowElement: documentTemplate.header.documentName.isShowElement,
      value: documentTemplate.header.documentName.value,
      isShowTaxInvoice: documentTemplate.header.documentName.isShowTaxInvoice,
      isShowNonTaxInvoice: documentTemplate.header.documentName.isShowNonTaxInvoice,
    },
    merchant: {
      isShowTextHeadOffice: documentTemplate.header.merchant.isShowTextHeadOffice,
      merchantAddressTemplate: documentTemplate.header.merchant.merchantAddressTemplate,
      isCustomTextDisplay: documentTemplate.header.merchant.isCustomTextDisplay,
      isShowClassification: documentTemplate.header.merchant.isShowClassification,
      merchantClassificationList: documentTemplate.header.merchant.merchantClassificationList,
      merchantTitle: {
        value: documentTemplate.header.merchant.title,
        isShowElement: true,
      },
      phoneNumber: {
        value: isTemplateMain ? "" : documentTemplate.header.merchant.phoneNumber.value,
        isShowElement: documentTemplate.header.merchant.phoneNumber.isShowElement,
      },
      email: {
        value: isTemplateMain ? "" : documentTemplate.header.merchant.email.value,
        isShowElement: documentTemplate.header.merchant.email.isShowElement,
      },
      website: {
        value: isTemplateMain
          ? ""
          : documentTemplate.header.merchant.website
          ? documentTemplate.header.merchant.website.value
          : "",
        isShowElement: documentTemplate.header.merchant.website
          ? documentTemplate.header.merchant.website.isShowElement
          : true,
      },
    },
    contact: {
      isShowContact: documentTemplate.header.contact.isShowContact,
      isCustomTextDisplay: documentTemplate.header.contact.isCustomTextDisplay,
      isShowTextHeadOffice: documentTemplate.header.contact.isShowTextHeadOffice,
      isShowContactCode: documentTemplate.header.contact.contactCode.isShowElement,
      isShowClassification: documentTemplate.header.contact.isShowClassification,
      contactClassificationList: documentTemplate.header.contact.contactClassificationList,
      contactTitle: {
        value: documentTemplate.header.contact.contactTitle,
        isShowElement: true,
      },
      dearTitle: {
        value: documentTemplate.header.contact.dearTitle.value,
        isShowElement: documentTemplate.header.contact.dearTitle.isShowElement,
      },
      phoneNumber: {
        value: isTemplateMain ? "" : documentTemplate.header.contact.phoneNumber.value,
        isShowElement: documentTemplate.header.contact.phoneNumber.isShowElement,
      },
      email: {
        value: isTemplateMain ? "" : documentTemplate.header.contact.email.value,
        isShowElement: documentTemplate.header.contact.email.isShowElement,
      },
      website: {
        value: isTemplateMain
          ? ""
          : documentTemplate.header.contact.website
          ? documentTemplate.header.contact.website.value
          : "",
        isShowElement: documentTemplate.header.contact.website
          ? documentTemplate.header.contact.website.isShowElement
          : true,
      },
    },
    documentInfo: {
      documentNoTitle: {
        value: documentTemplate.header.documentInfo.documentNoTitle.value,
        isShowElement: documentTemplate.header.documentInfo.documentNoTitle.isShowElement,
      },
      issedDateTitle: {
        value: documentTemplate.header.documentInfo.issedDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.issedDateTitle.isShowElement,
      },
      creditTitle: {
        value: documentTemplate.header.documentInfo.creditTitle.value,
        isShowElement: documentTemplate.header.documentInfo.creditTitle.isShowElement,
      },
      acceptedDateTitle: {
        value: documentTemplate.header.documentInfo.acceptedDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.acceptedDateTitle.isShowElement,
      },
      rejectedDateTitle: {
        value: documentTemplate.header.documentInfo.rejectedDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.rejectedDateTitle.isShowElement,
      },
      dueDateTitle: {
        value: documentTemplate.header.documentInfo.dueDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.dueDateTitle.isShowElement,
      },
      refTitle: {
        value: documentTemplate.header.documentInfo.refTitle.value,
        isShowElement: documentTemplate.header.documentInfo.refTitle.isShowElement,
      },
      taxInvoiceNumberTitle: {
        value: documentTemplate.header.documentInfo.taxInvoiceNumberTitle.value,
        isShowElement: documentTemplate.header.documentInfo.taxInvoiceNumberTitle.isShowElement,
      },
      taxInvoiceDateTimeTitle: {
        value: documentTemplate.header.documentInfo.taxInvoiceDateTimeTitle.value,
        isShowElement: documentTemplate.header.documentInfo.taxInvoiceDateTimeTitle.isShowElement,
      },
      dateOptionType: documentTemplate.header.documentInfo.dateOptionType,
      isCustomTextDisplay: documentTemplate.header.documentInfo.isCustomTextDisplay,
      isShowIssueDateValue: documentTemplate.header.documentInfo.isShowIssueDateValue,
      isShowClassification: documentTemplate.header.documentInfo.isShowClassification,
      documentInfoClassificationList: documentTemplate.header.documentInfo.documentInfoClassificationList,
    },
    merchantPerson: {
      isShowMerchantPerson: documentTemplate.header.merchantPerson.isShowMerchantPerson,
      isCustomTextDisplay: documentTemplate.header.merchantPerson.isCustomTextDisplay,
      merchantTitle: {
        value: "",
        isShowElement: documentTemplate.header.merchantPerson.merchantName.isShowElement,
      },
      merchantPersonTitle: {
        value: documentTemplate.header.merchantPerson.merchantPersonTitle.value,
        isShowElement: documentTemplate.header.merchantPerson.merchantPersonTitle.isShowElement,
      },
      phoneNumber: {
        value: "",
        isShowElement: documentTemplate.header.merchantPerson.phoneNumber.isShowElement,
      },
      email: {
        value: "",
        isShowElement: documentTemplate.header.merchantPerson.email.isShowElement,
      },
    },
    settingColumn: {
      isShowAmount: documentTemplate.detail.settigColumn.isShowAmount,
      isShowUnit: documentTemplate.detail.settigColumn.isShowUnit,
      isShowVatAmount: documentTemplate.detail.settigColumn.isShowVatAmount,
      isShowPreVatAmount: documentTemplate.detail.settigColumn.isShowPreVatAmount,
      isShowIncVatAmount: documentTemplate.detail.settigColumn.isShowIncVatAmount,
      isShowWhtAmount: documentTemplate.detail.settigColumn.isShowWhtAmount,
      isShowBilledAmount: documentTemplate.detail.settigColumn.isShowBilledAmount,
      isShowDocumentNumber: documentTemplate.detail.settigColumn.isShowDocumentNumber,
      isShowDueDate: documentTemplate.detail.settigColumn.isShowDueDate,
      isShowIssedDate: documentTemplate.detail.settigColumn.isShowIssedDate,
      isShowDiscount: documentTemplate.detail.settigColumn.isShowDiscount,
      isShowPrice: documentTemplate.detail.settigColumn.isShowPrice,
      isShowProductItems: documentTemplate.detail.settigColumn.isShowProductItems,
      isShowTaxInvoiceNo: documentTemplate.detail.settigColumn.isShowTaxInvoiceNo,
    },
    settingDescription: {
      isShowCode: documentTemplate.detail.settigDescription.isShowCode,
      isShowDescription: documentTemplate.detail.settigDescription.isShowDescription,
      isShowImage: documentTemplate.detail.settigDescription.isShowImage,
      isShowName: documentTemplate.detail.settigDescription.isShowName,
    },
    amountInfo: {
      amountInfoSettingType: documentTemplate.footer.amountInfo.amountInfoSettingType,
      isCustomTextDisplay: documentTemplate.footer.amountInfo.isCustomTextDisplay,
      depositTitle: {
        value: documentTemplate.footer.amountInfo.depositTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.depositTitle.isShowElement,
      },
      totalBeforeDeductTitle: {
        value: documentTemplate.footer.amountInfo.totalBeforeDeductTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.totalBeforeDeductTitle.isShowElement,
      },
      totalAfterDeductTitle: {
        value: documentTemplate.footer.amountInfo.totalAfterDeductTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.totalAfterDeductTitle.isShowElement,
      },
      discountTitle: {
        value: documentTemplate.footer.amountInfo.discountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.discountTitle.isShowElement,
      },
      netAmountTitle: {
        value: documentTemplate.footer.amountInfo.netAmountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.netAmountTitle.isShowElement,
      },
      nonVATAmountTitle: {
        value: documentTemplate.footer.amountInfo.nonVATAmountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.nonVATAmountTitle.isShowElement,
      },
      preVATAmountTitle: {
        value: documentTemplate.footer.amountInfo.preVATAmountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.preVATAmountTitle.isShowElement,
      },
      vatAmountTitle: {
        value: documentTemplate.footer.amountInfo.vatAmountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.vatAmountTitle.isShowElement,
      },
      zeroVATAmountTitle: {
        value: documentTemplate.footer.amountInfo.zeroVATAmountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.zeroVATAmountTitle.isShowElement,
      },
      totalDocumentAmountAfterTitle: {
        value: documentTemplate.footer.amountInfo.totalDocumentAmountAfterTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.totalDocumentAmountAfterTitle.isShowElement,
      },
      referenceTransactionAmountTitle: {
        value: documentTemplate.footer.amountInfo.referenceTransactionAmountTitle.value,
        isShowElement: documentTemplate.footer.amountInfo.referenceTransactionAmountTitle.isShowElement,
      },
    },
    summarizeInfo: {
      isShowSummary: documentTemplate.footer.summarizeInfo.isShowSummary ?? true,
      isCustomTextDisplay: documentTemplate.footer.summarizeInfo.isCustomTextDisplay,
      positionSummarizeDefault: documentTemplate.footer.summarizeInfo.positionSummarizeDefault,
      summaryAmountTitle: {
        value: documentTemplate.footer.summarizeInfo.summaryAmountTitle.value,
        isShowElement: documentTemplate.footer.summarizeInfo.summaryAmountTitle.isShowElement,
      },
      paymentAmountTitle: {
        value: documentTemplate.footer.summarizeInfo.paymentAmountTitle.value,
        isShowElement: documentTemplate.footer.summarizeInfo.paymentAmountTitle.isShowElement,
      },
      whtAmountTitle: {
        value: documentTemplate.footer.summarizeInfo.whtAmountTitle.value,
        isShowElement: documentTemplate.footer.summarizeInfo.whtAmountTitle.isShowElement,
      },
    },
    merchantPayment: {
      paymentElementType: documentTemplate.footer.payment.paymentElementType,
      settingPaymentGroupList: documentTemplate.footer.payment.settingPaymentGroupList,
      settingPaymentMethodChannel: documentTemplate.footer.payment.settingPaymentMethodChannel,
    },
    remark: {
      value: "",
      isShowElement: documentTemplate.footer.remark.isShowElement,
    },
    reason: {
      value: documentTemplate.footer.reason.value ? documentTemplate.footer.reason.value : "-",
      isShowElement: documentTemplate.footer.reason.isShowElement,
    },
    expenseClaimDetail: {
      idCard: {
        value: "",
        isShowElement: documentTemplate.footer.expenseClaimDetail.idCard.isShowElement,
      },
      expenseClaimNote: {
        value: "",
        isShowElement: documentTemplate.footer.expenseClaimDetail.expenseClaimNote.isShowElement,
      },
    },
    certified: {
      userCreateTitle: {
        value: documentTemplate.footer.certified.userCreateTitle.value,
        isShowElement: documentTemplate.footer.certified.userCreateTitle.isShowElement,
      },
      userApproveTitle: {
        value: documentTemplate.footer.certified.userApproveTitle.value,
        isShowElement: documentTemplate.footer.certified.userApproveTitle.isShowElement,
      },
      merchantStampTitle: {
        value: documentTemplate.footer.certified.merchantStampTitle.value,
        isShowElement: documentTemplate.footer.certified.merchantStampTitle.isShowElement,
      },
      receivedByTitle: {
        value: documentTemplate.footer.certified.receivedByTitle.value,
        isShowElement: documentTemplate.footer.certified.receivedByTitle.isShowElement,
      },
      stampTitle: {
        value: documentTemplate.footer.certified.stampTitle.value,
        isShowElement: documentTemplate.footer.certified.stampTitle.isShowElement,
      },
      userAcceptTitle: {
        value: documentTemplate.footer.certified.userAcceptTitle.value,
        isShowElement: documentTemplate.footer.certified.userAcceptTitle.isShowElement,
      },
      isShowUserAcceptUrl: documentTemplate.footer.certified.userAccept.isShowSignatureUrl,
      isShowUserAcceptDate: documentTemplate.footer.certified.userAccept.isShowAcceptDate,
      isShowUserAcceptName: documentTemplate.footer.certified.userAccept.isShowAcceptName,
      isShowUserCreateUrl: documentTemplate.footer.certified.userCreate.isShowSignatureUrl,
      isShowUserApproveUrl: documentTemplate.footer.certified.userApprove.isShowSignatureUrl,
      isShowUserCreateDate: documentTemplate.footer.certified.userCreate.isShowCreateDate,
      isShowUserApproveDate: documentTemplate.footer.certified.userApprove.isShowApproveDate,
      isShowUserApproveName: documentTemplate.footer.certified.userApprove.isShowApproveName,
      isShowUserCreateName: documentTemplate.footer.certified.userCreate.isShowCreateName,
      isShowMerchantStampUrl: documentTemplate.footer.certified.merchantStampUrl.isShowElement,
      isCustomTextDisplay: documentTemplate.footer.certified.isCustomTextDisplay,
      isShowQRCode: documentTemplate.footer.certified.isShowQRCode,
      settingCreateDate: documentTemplate.footer.certified.settingCreateDate,
      settingApproveDate: documentTemplate.footer.certified.settingApproveDate,
      settingAcceptDate: documentTemplate.footer.certified.settingAcceptDate,
      isShowUserCustomerName: documentTemplate.footer.certified.userCustomer.isShowUserCustomerName,
    },
  };

  return settingDocumentTemplate;
}

export function ConvertToSettingJournalDocumentTemplate(
  documentTemplate: JournalDocumentTemplateModel,
  isTemplateMain: boolean
) {
  let settingDocumentTemplate: SettingJournalDocumentTemplateModel = {
    colorCode: documentTemplate.header.colorCode,
    colorCodeCopy: documentTemplate.header.colorCodeCopy,
    isShowColorBackground: documentTemplate.header.isShowColorBackground,
    isShowColorBorder: documentTemplate.header.isShowColorBorder,
    isShowColorBackgroundCopy: documentTemplate.header.isShowColorBackgroundCopy,
    isShowColorBorderCopy: documentTemplate.header.isShowColorBorderCopy,
    language: documentTemplate.header.language,
    areaPunchingType: documentTemplate.header.areaPunchingType ?? SettingAreaPunchingType.None,
    merchantLogo: {
      value: "",
      isShowElement: documentTemplate.header.merchantLogo.isShowElement,
    },
    headType: {
      copyAmount: documentTemplate.header.headType.copyAmount,
      originalAmount: documentTemplate.header.headType.originalAmount,
      headerTitleType: documentTemplate.header.headType.headerOptionType,
      isShowDocumentSet: documentTemplate.header.headType.isShowDocumentSet,
      isShowHeaderOptionType: documentTemplate.header.headType.isShowHeaderOptionType,
    },
    documentNameType: documentTemplate.header.documentNameType ?? GetJournalNameTypeDefault(),
    merchant: {
      isShowTextHeadOffice: documentTemplate.header.merchant.isShowTextHeadOffice,
      isShowClassification: documentTemplate.header.merchant.isShowClassification,
      merchantClassificationList: documentTemplate.header.merchant.merchantClassificationList,
      merchantAddressTemplate: documentTemplate.header.merchant.merchantAddressTemplate,
      isCustomTextDisplay: documentTemplate.header.merchant.isCustomTextDisplay,
      merchantTitle: {
        value: documentTemplate.header.merchant.title,
        isShowElement: true,
      },
      phoneNumber: {
        value: isTemplateMain ? "" : documentTemplate.header.merchant.phoneNumber.value,
        isShowElement: documentTemplate.header.merchant.phoneNumber.isShowElement,
      },
      email: {
        value: isTemplateMain ? "" : documentTemplate.header.merchant.email.value,
        isShowElement: documentTemplate.header.merchant.email.isShowElement,
      },
      website: {
        value: isTemplateMain
          ? ""
          : documentTemplate.header.merchant.website
          ? documentTemplate.header.merchant.website.value
          : "",
        isShowElement: documentTemplate.header.merchant.website
          ? documentTemplate.header.merchant.website.isShowElement
          : true,
      },
    },
    contact: {
      isShowContact: documentTemplate.header.contact.isShowContact,
      isCustomTextDisplay: documentTemplate.header.contact.isCustomTextDisplay,
      isShowTextHeadOffice: documentTemplate.header.contact.isShowTextHeadOffice,
      isShowContactCode: documentTemplate.header.contact.contactCode.isShowElement,
      isShowClassification: documentTemplate.header.contact.isShowClassification,
      contactClassificationList: documentTemplate.header.contact.contactClassificationList,
      contactTitle: {
        value: documentTemplate.header.contact.contactTitle,
        isShowElement: true,
      },
      dearTitle: {
        value: documentTemplate.header.contact.dearTitle.value,
        isShowElement: documentTemplate.header.contact.dearTitle.isShowElement,
      },
      phoneNumber: {
        value: isTemplateMain ? "" : documentTemplate.header.contact.phoneNumber.value,
        isShowElement: documentTemplate.header.contact.phoneNumber.isShowElement,
      },
      email: {
        value: isTemplateMain ? "" : documentTemplate.header.contact.email.value,
        isShowElement: documentTemplate.header.contact.email.isShowElement,
      },
      website: {
        value: isTemplateMain
          ? ""
          : documentTemplate.header.contact.website
          ? documentTemplate.header.contact.website.value
          : "",
        isShowElement: documentTemplate.header.contact.website
          ? documentTemplate.header.contact.website.isShowElement
          : true,
      },
    },
    documentInfo: {
      documentNoTitle: {
        value: documentTemplate.header.documentInfo.documentNoTitle.value,
        isShowElement: documentTemplate.header.documentInfo.documentNoTitle.isShowElement,
      },
      issedDateTitle: {
        value: documentTemplate.header.documentInfo.issedDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.issedDateTitle.isShowElement,
      },
      refTitle: {
        value: documentTemplate.header.documentInfo.refTitle.value,
        isShowElement: documentTemplate.header.documentInfo.refTitle.isShowElement,
      },
      jonalTypeTitle: {
        value: documentTemplate.header.documentInfo.jonalTypeTitle.value,
        isShowElement: documentTemplate.header.documentInfo.jonalTypeTitle.isShowElement,
      },
      journalRefTaxDateTitle: {
        value: documentTemplate.header.documentInfo.journalRefTaxDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.journalRefTaxDateTitle.isShowElement,
      },
      journalRefTaxNumberTitle: {
        value: documentTemplate.header.documentInfo.journalRefTaxNumberTitle.value,
        isShowElement: documentTemplate.header.documentInfo.journalRefTaxNumberTitle.isShowElement,
      },
      dateOptionType: documentTemplate.header.documentInfo.dateOptionType,
      isCustomTextDisplay: documentTemplate.header.documentInfo.isCustomTextDisplay,
      isShowClassification: documentTemplate.header.documentInfo.isShowClassification,
      infoClassificationList: documentTemplate.header.documentInfo.infoClassificationList,
    },
    certified: {
      userCreateTitle: {
        value: documentTemplate.footer.certified.userCreateTitle.value,
        isShowElement: documentTemplate.footer.certified.userCreateTitle.isShowElement,
      },
      userApproveTitle: {
        value: documentTemplate.footer.certified.userApproveTitle.value,
        isShowElement: documentTemplate.footer.certified.userApproveTitle.isShowElement,
      },
      userReviewedTitle: {
        value: documentTemplate.footer.certified.userReviewedTitle.value,
        isShowElement: documentTemplate.footer.certified.userReviewedTitle.isShowElement,
      },
      isShowUserCreateUrl: documentTemplate.footer.certified.userCreate.isShowSignatureUrl,
      isShowUserApproveUrl: documentTemplate.footer.certified.userApprove.isShowSignatureUrl,
      isShowUserReviewedUrl: documentTemplate.footer.certified.userReviewed.isShowSignatureUrl,
      isShowUserCreateDate: documentTemplate.footer.certified.userCreate.isShowCreateDate,
      isShowUserApproveDate: documentTemplate.footer.certified.userApprove.isShowApproveDate,
      isShowUserCreateName: documentTemplate.footer.certified.userCreate.isShowCreateName,
      isShowUserApproveName: documentTemplate.footer.certified.userApprove.isShowApproveName,
      isShowUserReviewedDate: documentTemplate.footer.certified.userReviewed.isShowReviewedDate,
      isCustomTextDisplay: documentTemplate.footer.certified.isCustomTextDisplay,
      isShowQRCode: documentTemplate.footer.certified.isShowQRCode,
    },
  };

  return settingDocumentTemplate;
}

export function ConvertToSettingWithholdingTaxDocumentTemplate(
  documentTemplate: WithholdingTaxDocumentTemplateModel,
  isTemplateMain: boolean
) {
  let settingDocumentTemplate: SettingWitholdingTaxDocumentTemplateModel = {
    pageSize: documentTemplate.pageSize,
    displayType: documentTemplate.displayType,
    showDisplayType: documentTemplate.showDisplayType,
    documentNumber: {
      isShowRefOne: documentTemplate.referenceOne.isShowElement,
      isShowRefTwo: documentTemplate.referenceTwo.isShowElement,
      isShowWhtNumber: documentTemplate.number.isShowElement,
    },
    certified: {
      isShowUserCreateUrl: documentTemplate.userCreate.isShowSignatureUrl,
      isShowUserApproveUrl: documentTemplate.userApprove.isShowSignatureUrl,
      isShowUserCreateDate: documentTemplate.userCreate.isShowCreateDate,
      isShowUserApproveDate: documentTemplate.userApprove.isShowApproveDate,
      isShowUserApproveName: documentTemplate.userApprove.isShowApproveName,
      isShowUserCreateName: documentTemplate.userCreate.isShowCreateName,
      isShowMerchantStampUrl: documentTemplate.merchantStampUrl.isShowElement,
    },
    whtItem40XShowingType: documentTemplate.whtItem40XShowingType ?? SettingWhtItem40XShowingType.CombinedShowing,
  };

  return settingDocumentTemplate;
}

export function ConvertToSettingPP30xDocumentTemplate(
  documentTemplate: PP30DocumentTemplateModel,
  isTemplateMain: boolean
) {
  let settingDocumentTemplate: SettingPP30DocumentTemplateModel = {
    certified: {
      isShowUserCreateUrl: documentTemplate.userCreate.isShowSignatureUrl,
      isShowUserApproveUrl: documentTemplate.userApprove.isShowSignatureUrl,
      isShowUserCreateDate: documentTemplate.userCreate.isShowCreateDate,
      isShowUserApproveDate: documentTemplate.userApprove.isShowApproveDate,
      isShowUserCreateName: documentTemplate.userCreate.isShowCreateName,
      isShowUserApproveName: documentTemplate.userApprove.isShowApproveName,
      isShowMerchantStampUrl: documentTemplate.merchantStampUrl.isShowElement,
    },
    colorCode: documentTemplate.header.colorCode,
    isShowColorBackground: documentTemplate.header.isShowColorBackground,
    isShowColorBorder: documentTemplate.header.isShowColorBorder,
    language: documentTemplate.header.language,
    merchantLogo: documentTemplate.header.merchantLogo,
    headType: {
      copyAmount: documentTemplate.header.headType.copyAmount,
      originalAmount: documentTemplate.header.headType.originalAmount,
      headerTitleType: documentTemplate.header.headType.headerOptionType,
      isShowDocumentSet: documentTemplate.header.headType.isShowDocumentSet,
      isShowHeaderOptionType: documentTemplate.header.headType.isShowHeaderOptionType,
    },
    merchant: {
      isShowTextHeadOffice: documentTemplate.header.merchant.isShowTextHeadOffice,
      isShowClassification: documentTemplate.header.merchant.isShowClassification,
      merchantClassificationList: documentTemplate.header.merchant.merchantClassificationList,
      merchantAddressTemplate: documentTemplate.header.merchant.merchantAddressTemplate,
      isCustomTextDisplay: documentTemplate.header.merchant.isCustomTextDisplay,
      merchantTitle: {
        value: documentTemplate.header.merchant.title,
        isShowElement: true,
      },
      phoneNumber: {
        value: isTemplateMain ? "" : documentTemplate.header.merchant.phoneNumber.value,
        isShowElement: documentTemplate.header.merchant.phoneNumber.isShowElement,
      },
      email: {
        value: isTemplateMain ? "" : documentTemplate.header.merchant.email.value,
        isShowElement: documentTemplate.header.merchant.email.isShowElement,
      },
      website: {
        value: isTemplateMain
          ? ""
          : documentTemplate.header.merchant.website
          ? documentTemplate.header.merchant.website.value
          : "",
        isShowElement: documentTemplate.header.merchant.website
          ? documentTemplate.header.merchant.website.isShowElement
          : true,
      },
    },
    documentInfo: {
      formNumberTitle: {
        value: documentTemplate.header.documentInfo.formNumberTitle.value,
        isShowElement: documentTemplate.header.documentInfo.formNumberTitle.isShowElement,
      },
      issueDateTitle: {
        value: documentTemplate.header.documentInfo.issueDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.issueDateTitle.isShowElement,
      },
      formDateTitle: {
        value: documentTemplate.header.documentInfo.formDateTitle.value,
        isShowElement: documentTemplate.header.documentInfo.formDateTitle.isShowElement,
      },
      dateOptionType: documentTemplate.header.documentInfo.dateOptionType,
      isCustomTextDisplay: documentTemplate.header.documentInfo.isCustomTextDisplay,
    },
    pp30TransactionCertified: {
      userCreateTitle: {
        value: documentTemplate.footer.certified.userCreateTitle.value,
        isShowElement: documentTemplate.footer.certified.userCreateTitle.isShowElement,
      },
      userApproveTitle: {
        value: documentTemplate.footer.certified.userApproveTitle.value,
        isShowElement: documentTemplate.footer.certified.userApproveTitle.isShowElement,
      },
      isShowUserCreateUrl: documentTemplate.footer.certified.userCreate.isShowSignatureUrl,
      isShowUserApproveUrl: documentTemplate.footer.certified.userApprove.isShowSignatureUrl,
      isShowUserCreateDate: documentTemplate.footer.certified.userCreate.isShowCreateDate,
      isShowUserApproveDate: documentTemplate.footer.certified.userApprove.isShowApproveDate,
      isShowUserCreateName: documentTemplate.footer.certified.userCreate.isShowCreateName,
      isShowUserApproveName: documentTemplate.footer.certified.userApprove.isShowApproveName,
      isCustomTextDisplay: documentTemplate.footer.certified.isCustomTextDisplay,
      isShowQRCode: documentTemplate.footer.certified.isShowQRCode,
    },
    settingVatFormType: documentTemplate.detail.settingVatFormType,
    documentName: {
      isShowElement: documentTemplate.header.documentName.isShowElement,
      value: documentTemplate.header.documentName.value,
    },
  };
  return settingDocumentTemplate;
}

export function ConvertToSettingPndDocumentTemplate(
  documentTemplate: PndDocumentTemplateModel,
  isTemplateMain: boolean
) {
  let settingDocumentTemplate: SettingPndDocumentTemplateModel = {
    certified: {
      isShowUserCreateUrl: documentTemplate.userCreate.isShowSignatureUrl,
      isShowUserApproveUrl: documentTemplate.userApprove.isShowSignatureUrl,
      isShowUserCreateDate: documentTemplate.userCreate.isShowCreateDate,
      isShowUserApproveDate: documentTemplate.userApprove.isShowApproveDate,
      isShowUserCreateName: documentTemplate.userCreate.isShowCreateName,
      isShowUserApproveName: documentTemplate.userApprove.isShowApproveName,
      isShowMerchantStampUrl: documentTemplate.merchantStampUrl.isShowElement,
    },
  };

  return settingDocumentTemplate;
}

export function ConvertToSettingContactEnvelopeTemplate(
  documentTemplate: ContactEnvelopeDocumentTemplateModel,
  isTemplateMain: boolean
) {
  let settingDocumentTemplate: any = {
    pageSize: documentTemplate.header.pageSize,
    merchant: {
      merchantAddressTemplate: documentTemplate.header.merchant.merchantAddressTemplate,
      phoneNumber: {
        isShowElement: documentTemplate.header.merchant.phoneNumber.isShowElement,
      },
      website: {
        isShowElement: documentTemplate.header.merchant.website.isShowElement,
      },
      email: {
        isShowElement: documentTemplate.header.merchant.email.isShowElement,
      },
      line: {
        isShowElement: documentTemplate.header.merchant.line.isShowElement,
      },
      faxNumber: {
        isShowElement: documentTemplate.header.merchant.faxNumber.isShowElement,
      },
    },
    merchantLogo: {
      isShowElement: documentTemplate.header.merchantLogo.isShowElement,
    },
    contact: {
      isShowContactName: documentTemplate.contact.isShowContactName,
      isShowContactPosition: documentTemplate.contact.isShowContactPosition,
      isShowContactTel: documentTemplate.contact.isShowContactTel,
    },
  };

  return settingDocumentTemplate;
}

export function CalculateWithSettingCurrency(
  currencyAmount: number,
  currency: DocumentCurrencyModel | CurrencyDetailModel,
  settingCurrency: CurrencyCode
): number {
  if (currency.toCurrency.currencyCode === CurrencyCode.THB) {
    return currencyAmount;
  } else {
    if (settingCurrency === CurrencyCode.THB) {
      const netAmount = currencyAmount.Multiply(currency.exchangeRates).Divide(currency.exchangeRatioType);
      return netAmount;
    }
    return currencyAmount;
  }
}

export function SetIsUseCurrency(settingCurrency: CurrencyCode, toCurrency: CurrencyCode) {
  let isUseCurrency = true;
  if (settingCurrency === CurrencyCode.THB && toCurrency !== CurrencyCode.THB) {
    isUseCurrency = false;
  }
  return isUseCurrency;
}

export function CalculateCurrencyToTHB(amount: number, currency: DocumentCurrencyModel) {
  let totalAmount = amount * (currency.exchangeRates / currency.exchangeRatioType);
  return totalAmount;
}

export function SetAmountInfoCurrencyChanged(documentModel: OnlineViewModel, documentTemplate: DocumentTemplateModel) {
  const currency = documentModel.document.data.currency;
  const summary = documentModel.document.data.summary;
  const isUseCurrency = SetIsUseCurrency(
    documentTemplate.currency.settingCurrency,
    documentTemplate.currency.toCurrency.currencyCode
  );
  const discount = GetTotalDiscountAmount(
    documentModel.document.data,
    isUseCurrency,
    GetDepositReferences(
      documentModel.document.data.deposit,
      documentModel.template.settingCurrency,
      isUseCurrency
    ).total.ToNumber()
  ).FormatMoney();

  const deposit = GetDepositReferences(
    documentModel.document.data.deposit,
    documentModel.template.settingCurrency,
    isUseCurrency
  );

  const totalBeforeDeductAmount = GetTotalBeforeDeductAmount(
    documentModel.document.data,
    isUseCurrency,
    deposit.total.ToNumber()
  );

  const totalAfterDeductAmount = GetTotalAfterDeductAmount(
    documentModel.document.data,
    isUseCurrency,
    deposit.total.ToNumber()
  );

  documentTemplate.footer.amountInfo.discount = discount;
  documentTemplate.footer.amountInfo.totalBeforeDeductAmount = totalBeforeDeductAmount.ToPeakTransactionItemFormat();
  documentTemplate.footer.amountInfo.totalAfterDeductAmount = totalAfterDeductAmount.ToPeakTransactionItemFormat();
  documentTemplate.footer.amountInfo.deposit.total = deposit.total;
  documentTemplate.footer.amountInfo.netAmountTh = ConvertAmountToThaiWord(
    isUseCurrency ? currency.netAmount.ToNumber() : summary.netAmount.ToNumber(),
    documentTemplate.currency.settingCurrency
  );
  documentTemplate.footer.amountInfo.netAmountEn = ConvertAmountToEnglishWord(
    isUseCurrency ? currency.netAmount.ToNumber() : summary.netAmount.ToNumber(),
    documentTemplate.currency.settingCurrency
  );
  documentTemplate.footer.amountInfo.nonVATAmount = isUseCurrency
    ? currency.vatExemptedTotal
    : summary.vatExemptedTotal;
  documentTemplate.footer.amountInfo.preVATAmount = isUseCurrency ? currency.preVatTotal : summary.preVatTotal;
  documentTemplate.footer.amountInfo.vatAmount = isUseCurrency ? currency.vatTotal : summary.vatTotal;
  documentTemplate.footer.amountInfo.zeroVATAmount = isUseCurrency ? currency.zeroVatTotal : summary.zeroVatTotal;

  documentTemplate.footer.amountInfo.referenceTransactionAmount = isUseCurrency
    ? documentModel.document.data.summaryDocumentModel.referenceTransactionAmount
    : CalculateCurrencyToTHB(documentModel.document.data.summaryDocumentModel.referenceTransactionAmount, currency);

  documentTemplate.footer.amountInfo.totalDocumentAmountAfter = isUseCurrency
    ? documentModel.document.data.summaryDocumentModel.totalDocumentAmountAfter
    : CalculateCurrencyToTHB(documentModel.document.data.summaryDocumentModel.totalDocumentAmountAfter, currency);
}

export function SetSummarizeInfoCurrencyChanged(
  documentModel: OnlineViewModel,
  documentTemplate: DocumentTemplateModel
) {
  const currency = documentModel.document.data.currency;
  const summary = documentModel.document.data.summary;
  const isUseCurrency = SetIsUseCurrency(
    documentTemplate.currency.settingCurrency,
    documentTemplate.currency.toCurrency.currencyCode
  );

  documentTemplate.footer.summarizeInfo.summaryAmount = isUseCurrency ? currency.netAmount : summary.netAmount;
  documentTemplate.footer.summarizeInfo.paymentAmount = isUseCurrency
    ? currency.netAmount - currency.whtTotal
    : summary.netAmount - summary.whtTotal;
  documentTemplate.footer.summarizeInfo.whtAmount = isUseCurrency ? currency.whtTotal : summary.whtTotal;
}

export function SetProductListCurrencyChanged(documentModel: OnlineViewModel, documentTemplate: DocumentTemplateModel) {
  const currency = documentModel.document.data.currency;

  documentTemplate.detail.productList.forEach((element, index) => {
    const productItem = documentModel.document.data.items[index];
    element.price = CalculateWithSettingCurrency(
      productItem.price,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.discount =
      productItem.discount.discountType == DiscountType.Amount
        ? CalculateWithSettingCurrency(
            productItem.discount.discountAmount,
            currency,
            documentTemplate.currency.settingCurrency
          ).ToPeakTransactionItemFormat()
        : productItem.discount.discountAmount.ToPeakTransactionItemFormat() + "%";
    element.preVatAmount = CalculateWithSettingCurrency(
      productItem.subTotal,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.incVatAmount = CalculateWithSettingCurrency(
      productItem.incVat,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.whtAmount = GetWhtAmount(productItem.wht, currency, documentTemplate.currency.settingCurrency);
  });
}

export function SetBillingListCurrencyChanged(documentModel: OnlineViewModel, documentTemplate: DocumentTemplateModel) {
  const currency = documentTemplate.currency;
  documentTemplate.detail.billingList.forEach((element, billingIndex) => {
    const billingItem = documentModel.document.data.billing[billingIndex];
    element.wht = GetWhtAmount(billingItem.wht, documentTemplate.currency, documentTemplate.currency.settingCurrency);
    element.productItems.forEach((item, itemIndex) => {
      const productItem = billingItem.items[itemIndex];
      item.pricePerItem = CalculateWithSettingCurrency(
        productItem.price,
        currency,
        documentTemplate.currency.settingCurrency
      );
      item.preVatAmount = CalculateWithSettingCurrency(
        productItem.subTotal,
        currency,
        documentTemplate.currency.settingCurrency
      );
      item.whtAmount = GetWhtAmount(productItem.wht, currency, documentTemplate.currency.settingCurrency);
    });
  });
}

export function SetAssetGroupsCurrencyChanged(documentModel: OnlineViewModel, documentTemplate: DocumentTemplateModel) {
  const currency = documentModel.document.data.currency;

  documentTemplate.detail.assetGroups.forEach((element, index) => {
    const assetGroupItem = documentModel.document.data.assetGroups[index];
    element.price = CalculateWithSettingCurrency(
      assetGroupItem.price,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.discount =
      assetGroupItem.discount.discountType == DiscountType.Amount
        ? CalculateWithSettingCurrency(
            assetGroupItem.discount.discountAmount,
            currency,
            documentTemplate.currency.settingCurrency
          ).ToPeakTransactionItemFormat()
        : assetGroupItem.discount.discountAmount.ToPeakTransactionItemFormat() + "%";
    element.preVatAmount = CalculateWithSettingCurrency(
      assetGroupItem.subTotal,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.incVatAmount = CalculateWithSettingCurrency(
      assetGroupItem.incVat,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.whtAmount = GetWhtAmount(assetGroupItem.wht, currency, documentTemplate.currency.settingCurrency);
  });
}

export function SetAssetsCurrencyChanged(documentModel: OnlineViewModel, documentTemplate: DocumentTemplateModel) {
  const currency = documentModel.document.data.currency;

  documentTemplate.detail.assets.forEach((element, index) => {
    const assetItem = documentModel.document.data.assets[index];
    element.price = CalculateWithSettingCurrency(assetItem.price, currency, documentTemplate.currency.settingCurrency);
    element.discount =
      assetItem.discount.discountType == DiscountType.Amount
        ? CalculateWithSettingCurrency(
            assetItem.discount.discountAmount,
            currency,
            documentTemplate.currency.settingCurrency
          ).ToPeakTransactionItemFormat()
        : assetItem.discount.discountAmount.ToPeakTransactionItemFormat() + "%";
    element.preVatAmount = CalculateWithSettingCurrency(
      assetItem.subTotal,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.incVatAmount = CalculateWithSettingCurrency(
      assetItem.incVat,
      currency,
      documentTemplate.currency.settingCurrency
    );
    element.whtAmount = GetWhtAmount(assetItem.wht, currency, documentTemplate.currency.settingCurrency);
  });
}

export function ConvertToSettingExecutiveSummaryTemplate(
  documentTemplate: ExecutiveSummaryDocumentTemplateModel,
  isTemplateMain: boolean
) {
  let settingDocumentTemplate: SettingExecutiveSummaryDocumentTemplateModel = {
    documentName: {
      headerOptionType: documentTemplate.header.documentName.headerOptionName,
      isShowElement: documentTemplate.header.documentName.isShowElement,
      value: documentTemplate.header.documentName.value,
    },
    header: {
      originalAmount: documentTemplate.header.originalAmount,
      isShowCreateDate: documentTemplate.header.createDate.isShowElement,
      isShowCreateUser: documentTemplate.header.createUser.isShowElement,
      isShowPeriodDate: documentTemplate.header.periodDate.isShowElement,
    },
    merchantLogo: {
      isShowElement: documentTemplate.header.merchantLogo.isShowElement,
      value: "",
    },
  };

  return settingDocumentTemplate;
}

export function GetURLName(transactionType: TransactionType, financeType: FinanceType) {
  let urlName = "";
  switch (transactionType) {
    case TransactionType.Quotation: {
      if (financeType === FinanceType.InFlow) {
        urlName = "quotation";
      } else if (financeType === FinanceType.OutFlow) {
        urlName = "purchaseOrder";
      }
      break;
    }
    case TransactionType.Invoice: {
      if (financeType === FinanceType.InFlow) {
        urlName = "invoice";
      } else if (financeType === FinanceType.OutFlow) {
        urlName = "expenses";
      }
      break;
    }
    case TransactionType.Receipt: {
      if (financeType === FinanceType.InFlow) {
        urlName = "receipt";
      }
      break;
    }
    case TransactionType.TaxInvoice: {
      if (financeType === FinanceType.InFlow) {
        urlName = "taxInvoice";
      }
      break;
    }
    case TransactionType.DailyJournal: {
      urlName = "dailyJournal";
      break;
    }
    case TransactionType.BillingNote: {
      if (financeType === FinanceType.InFlow) {
        urlName = "billingNote";
      } else if (financeType === FinanceType.OutFlow) {
        urlName = "combinePaymentNote";
      }
      break;
    }
    case TransactionType.CreditNote: {
      if (financeType === FinanceType.InFlow) {
        urlName = "creditNote";
      } else if (financeType === FinanceType.OutFlow) {
        urlName = "creditNoteExpense";
      }
      break;
    }
  }
  return urlName;
}
export function GetDocumentHeaderSizeClass(documentHeaderSize: DocumentHeaderSize, documentFontType: DocumentFontType) {
  let className = "";

  switch (documentHeaderSize) {
    case DocumentHeaderSize.Small:
      className = "documentHeaderSmall";
      break;
    case DocumentHeaderSize.Medium:
      className = "documentHeaderMedium";
      break;
    case DocumentHeaderSize.Large:
      className = "documentHeaderLarge";
      break;
  }

  return `${className}${documentFontType == DocumentFontType.THSarabunNew ? "Sarabun" : ""}`;
}
export function CheckIsCustomizeDocument() {
  const urlEcmi: any = router.currentRoute.query.ecmi;
  const customizeId = urlEcmi ? urlEcmi.PeakDecryptionToString() : "";
  return customizeId ? true : false;
}

export function GetDepositReferences(
  depositRefList: DepositReferenceItemModel[],
  settingCurrency: CurrencyCode,
  isUseCurrency: boolean
) {
  const transactionNumbers = [];
  let total = 0;
  if (depositRefList && depositRefList.length > 0) {
    for (const item of depositRefList) {
      transactionNumbers.push(item.transactionNumber);
      total += isUseCurrency ? item.currency.subTotal : item.summary.subTotal;
    }
  }
  return {
    transactionNumbers,
    total: total.ToPeakTransactionItemFormat(),
  };
}

export function GetTotalBeforeDeductAmount(data: DocumentDataModel, isUseCurrency: boolean, deposit: number): number {
  let subTotalAmount = 0;
  if (data.taxStatusType == TaxStatusType.IncludeTax) {
    if (data.discount.discountAmount || (data.deposit && data.deposit.length)) {
      let arrayToSumSubTotal = [];
      if (data.assetGroups && data.assetGroups.length > 0) {
        arrayToSumSubTotal = data.assetGroups;
      } else if (data.assets && data.assets.length > 0) {
        arrayToSumSubTotal = data.assets;
      } else {
        arrayToSumSubTotal = data.items;
      }
      arrayToSumSubTotal.forEach((item: DocumentItemBaseModel | DocumentItemAssetGroupBaseModel) => {
        if (item.vatType == ProductVatType.SevenPercent) {
          subTotalAmount += item.netAmount.Multiply(100).Divide(107);
        } else {
          subTotalAmount += item.subTotal;
        }
      });

      return isUseCurrency ? subTotalAmount : CalculateCurrencyToTHB(subTotalAmount, data.currency);
    } else {
      return isUseCurrency ? data.currency.preVatTotal : data.summary.preVatTotal;
    }
  } else {
    subTotalAmount = isUseCurrency ? data.currency.subTotal : data.summary.subTotal;
  }
  let discountAmount = 0;
  let subTotalAmountBeforeDeduct = 0;
  switch (data.discount.discountType) {
    case DiscountType.Amount:
      discountAmount = isUseCurrency
        ? data.discount.discountAmount
        : CalculateCurrencyToTHB(data.discount.discountAmount, data.currency);
      subTotalAmountBeforeDeduct = deposit + subTotalAmount + discountAmount;
      break;
    case DiscountType.Percent:
      discountAmount = data.discount.discountAmount;
      subTotalAmountBeforeDeduct = ((deposit + subTotalAmount) / (100 - discountAmount)) * 100;
      break;
  }
  return subTotalAmountBeforeDeduct;
}

export function GetTotalAfterDeductAmount(data: DocumentDataModel, isUseCurrency: boolean, deposit: number): number {
  if (data.taxStatusType == TaxStatusType.IncludeTax && data.discount.discountType == DiscountType.Amount) {
    return isUseCurrency ? data.currency.subTotal : data.summary.subTotal;
  }

  const subTotalAmountBeforeDeduct = GetTotalBeforeDeductAmount(data, isUseCurrency, deposit);
  let discountAmount = 0;

  switch (data.discount.discountType) {
    case DiscountType.Amount:
      discountAmount = isUseCurrency
        ? data.discount.discountAmount
        : CalculateCurrencyToTHB(data.discount.discountAmount, data.currency);
      break;
    case DiscountType.Percent:
      discountAmount = subTotalAmountBeforeDeduct * (data.discount.discountAmount / 100);
      break;
  }

  const subTotalAmountAfterDeduct = subTotalAmountBeforeDeduct - discountAmount - deposit;
  return subTotalAmountAfterDeduct;
}

export function GetTotalDiscountAmount(data: DocumentDataModel, isUseCurrency: boolean, deposit: number): number {
  const subTotalAmountBeforeDeduct = GetTotalBeforeDeductAmount(data, isUseCurrency, deposit);

  if (
    data.taxStatusType == TaxStatusType.IncludeTax &&
    data.discount.discountType == DiscountType.Amount &&
    data.discount.discountAmount
  ) {
    let subTotal = isUseCurrency ? data.currency.subTotal : data.summary.subTotal;
    const totalDiscount = subTotalAmountBeforeDeduct - subTotal - deposit;
    return totalDiscount;
  }
  let discountAmount = 0;

  switch (data.discount.discountType) {
    case DiscountType.Amount:
      discountAmount = isUseCurrency
        ? data.discount.discountAmount
        : CalculateCurrencyToTHB(data.discount.discountAmount, data.currency);
      break;
    case DiscountType.Percent:
      discountAmount = data.discount.discountAmount;
      break;
  }

  return discountAmount;
}

export function GetClassificationsList(data: OnlineViewModel | JournalOnlineViewModel) {
  if (data.document.data.classifications) {
    const classificationList: ClassificationItem[] = [];
    for (const item of data.document.data.classifications) {
      const newItem = { name: item.name, number: item.classificationNumber, id: item.classificationId };

      item.classificationItems.forEach((classificationItem) => {
        classificationList.push({
          ...newItem,
          displayName: classificationItem.name,
        });
      });
    }
    return classificationList;
  }
  return [];
}

export function GetClassificationsListForDisplay(
  classificationList: ClassificationItem[],
  settingClassificationList: AllocationItemModel[]
) {
  const classificationDisplayList: ClassificationItem[] = [];
  settingClassificationList.forEach((item) => {
    const matchIdSetting = classificationList.filter((x) => x.id == item.id);
    if (matchIdSetting) {
      if (matchIdSetting.length > 1) {
        const mergeItem = {
          ...matchIdSetting[0],
        };
        mergeItem.displayName = matchIdSetting.reduce((prev, acc, index) => {
          return `${(prev += acc.displayName)}${index != matchIdSetting.length - 1 ? "," : ""} `;
        }, "");
        classificationDisplayList.push(mergeItem);
      } else {
        matchIdSetting.forEach((item) => classificationDisplayList.push(item));
      }
    }
  });
  return classificationDisplayList;
}
export function GetDocumentColorForMobile(
  transactionType: TransactionType,
  financeType: FinanceType,
  expenseType: ExpenseType
): string {
  switch (transactionType) {
    case TransactionType.CreditNote:
      if (financeType == FinanceType.InFlow) {
        return "#B12392";
      } else if (financeType == FinanceType.OutFlow) {
        return "#33355A";
      }
    case TransactionType.DebitNote:
      if (financeType == FinanceType.InFlow) {
        return "#F1520F";
      } else if (financeType == FinanceType.OutFlow) {
        return "#33355A";
      }
    case TransactionType.Deposit:
      return financeType == FinanceType.InFlow ? "#3297FF" : "#33355A";
    case TransactionType.GoodsReceipt:
    case TransactionType.InvoiceReceipt:
      return "#33355A";
    case TransactionType.Invoice:
      if (financeType == FinanceType.InFlow) {
        return "#3297FF";
      } else if (
        financeType == FinanceType.OutFlow &&
        (expenseType == ExpenseType.PurchaseInventory || expenseType == ExpenseType.PurchaseAsset)
      ) {
        return "#FFA350";
      } else {
        return "#33355A";
      }
    case TransactionType.TaxInvoice:
      return "#3297FF";
    case TransactionType.BillingNote:
      return "#40CBDE";
    case TransactionType.Receipt:
      return "#3BB66F";
    case TransactionType.Quotation:
      return "#6C6DF2";
    case TransactionType.PurchaseRequisition:
      return "#33355A";
    default:
      return "#3297ff";
  }
}
export function GetDefaultIsShowWHTRefNumber(transactionType: TransactionType, financeType: FinanceType) {
  return (
    financeType == FinanceType.OutFlow ||
    !(
      transactionType == TransactionType.Receipt ||
      transactionType == TransactionType.CreditNote ||
      transactionType == TransactionType.Deposit ||
      transactionType == TransactionType.DebitNote
    )
  );
}

export function IsCanEditShowWHTRefNumber(transactionType: TransactionType, financeType: FinanceType) {
  return (
    financeType == FinanceType.InFlow &&
    (transactionType == TransactionType.Receipt ||
      transactionType == TransactionType.CreditNote ||
      transactionType == TransactionType.Deposit ||
      transactionType == TransactionType.DebitNote)
  );
}

export function SetValueForContactAndMerchantInfo(
  settingTemplate:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
    | SettingContactEnvelopeDocumentTemplateModel
    | SettingExecutiveSummaryDocumentTemplateModel
    | SettingPndDocumentTemplateModel
    | SettingWitholdingTaxDocumentTemplateModel,
  documentDetail:
    | OnlineViewModel
    | JournalOnlineViewModel
    | OnlineViewCustomizeModel
    | PP30OnlineViewModel
    | PndOnlineViewModel
    | null
):
  | SettingDocumentTemplateModel
  | SettingJournalDocumentTemplateModel
  | SettingPP30DocumentTemplateModel
  | SettingContactEnvelopeDocumentTemplateModel
  | SettingExecutiveSummaryDocumentTemplateModel
  | SettingPndDocumentTemplateModel
  | SettingWitholdingTaxDocumentTemplateModel {
  if (documentDetail instanceof OnlineViewModel) {
    const newSettingTemplate:
      | SettingDocumentTemplateModel
      | SettingJournalDocumentTemplateModel
      | SettingPP30DocumentTemplateModel
      | SettingContactEnvelopeDocumentTemplateModel
      | SettingExecutiveSummaryDocumentTemplateModel
      | SettingPndDocumentTemplateModel
      | SettingWitholdingTaxDocumentTemplateModel = settingTemplate;

    if ("merchant" in newSettingTemplate) {
      newSettingTemplate.merchant.phoneNumber.value = GetValueForContactAndMerchantInfo(
        newSettingTemplate.merchant.phoneNumber.value,
        documentDetail.document.data.merchant.phoneNumber,
        documentDetail.template.merchant.phoneNumber.value
      );
      newSettingTemplate.merchant.email.value = GetValueForContactAndMerchantInfo(
        newSettingTemplate.merchant.email.value,
        documentDetail.document.data.merchant.email,
        documentDetail.template.merchant.email.value
      );
      if (newSettingTemplate.merchant.website) {
        newSettingTemplate.merchant.website.value = GetValueForContactAndMerchantInfo(
          newSettingTemplate.merchant.website?.value,
          documentDetail.document.data.merchant.website,
          documentDetail.template.merchant.website?.value ?? ""
        );
      }
    }
    if ("contact" in newSettingTemplate) {
      if ("phoneNumber" in newSettingTemplate.contact) {
        newSettingTemplate.contact.phoneNumber.value = GetValueForContactAndMerchantInfo(
          newSettingTemplate.contact.phoneNumber.value,
          documentDetail.document.data.contact.phoneNumber,
          documentDetail.template.contact.phoneNumber.value
        );
      }
      if ("email" in newSettingTemplate.contact) {
        newSettingTemplate.contact.email.value = GetValueForContactAndMerchantInfo(
          newSettingTemplate.contact.email.value,
          documentDetail.document.data.contact.email,
          documentDetail.template.contact.email.value
        );
      }
      if ("website" in newSettingTemplate.contact) {
        if (newSettingTemplate.contact.website) {
          newSettingTemplate.contact.website.value = GetValueForContactAndMerchantInfo(
            newSettingTemplate.contact.website?.value,
            documentDetail.document.data.contact.website,
            documentDetail.template.contact.website?.value ?? ""
          );
        }
      }
    }
    return newSettingTemplate;
  } else {
    return settingTemplate;
  }
}

function GetValueForContactAndMerchantInfo(newTemplateValue: string, documentValue: string, templateValue: string) {
  if (newTemplateValue === "-") return "";
  if (newTemplateValue !== documentValue || templateValue) return newTemplateValue;
  return "";
}

export function CheckIsNotToSaveFromMainSetting(
  getDocumentDetail:
    | OnlineViewModel
    | JournalOnlineViewModel
    | OnlineViewCustomizeModel
    | PP30OnlineViewModel
    | PndOnlineViewModel
    | null
): boolean {
  return (
    getDocumentDetail instanceof OnlineViewCustomizeModel ||
    Boolean(getDocumentDetail?.isMainTemplate) ||
    !Boolean(getDocumentDetail?.doesHaveOwnTemplate)
  );
}
